/* eslint-disable */
<template>
  <svg
    id="emDeTYZbN5z1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 32 32"
    shape-rendering="geometricPrecision"
    text-rendering="geometricPrecision"
  >
    <path
      id="emDeTYZbN5z2"
      d="M6.6732,10.1497l-.26689,3.4696l2.13511-.5338l4.80398-2.9358l2.402,1.6013l5.0709,1.8683l4.804.2669-.5338-3.2027-1.8682-2.9358-2.1351-1.60133-3.7364-.80067h-3.7365l-1.8682.53378-2.13512.80067L6.6732,10.1497Z"
      clip-rule="evenodd"
      fill="#3CA091"
      fill-rule="evenodd"
    />
    <path
      id="emDeTYZbN5z3"
      d="M6.19632,15.3799h-.49375c-1.10759,0-2.01501.9051-2.01501,2.0219c0,1.1167.90742,2.022,2.01501,2.022.29358,0,.49375,0,.49375,0v-4.0439ZM25.5858,19.4238c0,0,.2002,0,.4937,0c1.121,0,2.0284-.9053,2.0284-2.022c0-1.1168-.9074-2.0219-2.0284-2.0219-.2935,0-.4937,0-.4937,0v4.0439Z"
      clip-rule="evenodd"
      fill="#dcf4f5"
      fill-rule="evenodd"
    />
    <path
      id="emDeTYZbN5z4"
      d="M5.57907,14.7706c-1.38782.0641-2.50876,1.2184-2.50876,2.6315c0,1.4546,1.18766,2.6342,2.6422,2.6342h.05338c.37365,2.0284,1.36114,3.9113,2.84237,5.3912c1.93494,1.9336,4.55044,3.0199,7.28604,3.0199s5.3512-1.0863,7.2861-3.0199c1.4812-1.4799,2.4687-3.3628,2.8424-5.3912h.0533c1.4546,0,2.6422-1.1796,2.6422-2.6342c0-1.4131-1.1209-2.5674-2.5087-2.6315v-1.2704c0-2.3659-.9475-4.63583-2.6155-6.30922-1.6814-1.6734-3.95-2.61286-6.3119-2.61286-.9208,0-1.8549,0-2.7757,0-2.362,0-4.63052.93946-6.31192,2.61286C6.52653,8.86437,5.57907,11.1343,5.57907,13.5002v1.2704Zm19.40283-.2789c-4.4837-.0827-8.3937-1.0475-11.6097-3.5523-1.9483,1.5653-4.25685,2.6716-6.56544,3.2027v3.9967c0,2.4086.9608,4.7199,2.66889,6.424c1.69475,1.7041,4.00335,2.6609,6.41865,2.6609s4.724-.9568,6.4187-2.6609c1.7081-1.7041,2.6689-4.0154,2.6689-6.424v-3.6471ZM14.133841,22.260072c.52.26,1.08.3,1.760459.290328s1.379541-.010328,1.919541-.270328c.48-.14.6865-.0456.86.24.1734.2869-.0197.6612-.3.84-.84.38-1.72.42-2.479541.414028-.720459-.014028-1.540459-.094028-2.260459-.414028-.2802-.1788-.5135-.5531-.34-.84.1735-.2856.5598-.4401.84-.26ZM15.3472,17.7838l-.814,2.1351c-.0667.1882-.04.399.0801.5645.1067.1641.2935.2629.4937.2629h1.0676c.3469,0,.6138-.2736.6138-.6112s-.2669-.6112-.6138-.6112c0,0-.209969.051103-.1869,0c.205509-.45524.4938-1.3091.4938-1.3091.1201-.3149-.04-.6685-.347-.7873-.3202-.1188-.6672.0414-.7873.3563ZM26.2096,15.997c.7206.0614,1.2811.6672,1.2811,1.4051s-.5605,1.3438-1.2811,1.4052v-2.8103Zm-20.63053,0v2.8103c-.7206-.0614-1.28107-.6672-1.28107-1.4052s.56047-1.3437,1.28107-1.4051Zm6.40533-.347c.7606,0,1.3878.6205,1.3878,1.3865c0,.7646-.6272,1.3865-1.3878,1.3865s-1.3878-.6219-1.3878-1.3865c0-.766.6272-1.3865,1.3878-1.3865Zm8.02,0c.774,0,1.3878.6205,1.3878,1.3865c0,.7646-.6138,1.3865-1.3878,1.3865-.7606,0-1.3878-.6219-1.3878-1.3865c0-.766.6272-1.3865,1.3878-1.3865Zm4.9775-2.382c-.0667-1.9576-.8674-3.82315-2.2552-5.2123-1.4412-1.44387-3.4028-2.25522-5.4445-2.25522-.9208,0-1.8549,0-2.7757,0-2.0417,0-4.0033.81135-5.44453,2.25522-1.29441,1.29708-2.08173,3.0078-2.22852,4.8213c2.17514-.5511,4.35025-1.6547,6.13845-3.19195.2268-.19483.5605-.19616.7873-.00533C16.8284,12.2419,20.6183,13.184,24.9819,13.268Z"
      clip-rule="evenodd"
      fill="#141414"
      fill-rule="evenodd"
    />
  </svg>
</template>

<script>
export default {
  /* eslint-disable */
  name: 'Happy',
  props: {
    eventName: {
      type: String,
      default: 'playHappy'
    }
  },
  data() {
    return {
      player: null
    };
  },
  mounted() {
    setTimeout(() => {
      !(function (t, e) {
        'object' === typeof exports && 'undefined' !== typeof module
          ? (module.exports = e())
          : 'function' === typeof __SVGATOR_DEFINE__ && __SVGATOR_DEFINE__.amd
          ? __SVGATOR_DEFINE__(e)
          : (((t = 'undefined' !== typeof globalThis ? globalThis : t || self).__SVGATOR_PLAYER__ =
              t.__SVGATOR_PLAYER__ || {}),
            (t.__SVGATOR_PLAYER__['91c80d77'] = e()));
      })(this, function () {
        'use strict';
        function t(t, e) {
          var n = Object.keys(t);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(t);
            e &&
              (r = r.filter(function (e) {
                return Object.getOwnPropertyDescriptor(t, e).enumerable;
              })),
              n.push.apply(n, r);
          }
          return n;
        }
        function e(e) {
          for (var n = 1; n < arguments.length; n++) {
            var r = null != arguments[n] ? arguments[n] : {};
            n % 2
              ? t(Object(r), !0).forEach(function (t) {
                  u(e, t, r[t]);
                })
              : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
              : t(Object(r)).forEach(function (t) {
                  Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                });
          }
          return e;
        }
        function n(t) {
          return (n =
            'function' === typeof Symbol && 'symbol' === typeof Symbol.iterator
              ? function (t) {
                  return typeof t;
                }
              : function (t) {
                  return t &&
                    'function' === typeof Symbol &&
                    t.constructor === Symbol &&
                    t !== Symbol.prototype
                    ? 'symbol'
                    : typeof t;
                })(t);
        }
        function r(t, e) {
          if (!(t instanceof e)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }
        function i(t, e) {
          for (var n = 0; n < e.length; n++) {
            var r = e[n];
            (r.enumerable = r.enumerable || !1),
              (r.configurable = !0),
              'value' in r && (r.writable = !0),
              Object.defineProperty(t, r.key, r);
          }
        }
        function o(t, e, n) {
          return e && i(t.prototype, e), n && i(t, n), t;
        }
        function u(t, e, n) {
          return (
            e in t
              ? Object.defineProperty(t, e, {
                  value: n,
                  enumerable: !0,
                  configurable: !0,
                  writable: !0
                })
              : (t[e] = n),
            t
          );
        }
        function a(t) {
          return (a = Object.setPrototypeOf
            ? Object.getPrototypeOf
            : function (t) {
                return t.__proto__ || Object.getPrototypeOf(t);
              })(t);
        }
        function l(t, e) {
          return (l =
            Object.setPrototypeOf ||
            function (t, e) {
              return (t.__proto__ = e), t;
            })(t, e);
        }
        function s() {
          if ('undefined' === typeof Reflect || !Reflect.construct) {
            return !1;
          }
          if (Reflect.construct.sham) {
            return !1;
          }
          if ('function' === typeof Proxy) {
            return !0;
          }
          try {
            return (
              Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
            );
          } catch (t) {
            return !1;
          }
        }
        function f(t, e, n) {
          return (f = s()
            ? Reflect.construct
            : function (t, e, n) {
                var r = [null];
                r.push.apply(r, e);
                var i = new (Function.bind.apply(t, r))();
                return n && l(i, n.prototype), i;
              }).apply(null, arguments);
        }
        function c(t, e) {
          if (e && ('object' === typeof e || 'function' === typeof e)) {
            return e;
          }
          if (void 0 !== e) {
            throw new TypeError('Derived constructors may only return object or undefined');
          }
          return (function (t) {
            if (void 0 === t) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return t;
          })(t);
        }
        function h(t, e, n) {
          return (h =
            'undefined' !== typeof Reflect && Reflect.get
              ? Reflect.get
              : function (t, e, n) {
                  var r = (function (t, e) {
                    for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = a(t)); ) {}
                    return t;
                  })(t, e);
                  if (r) {
                    var i = Object.getOwnPropertyDescriptor(r, e);
                    return i.get ? i.get.call(n) : i.value;
                  }
                })(t, e, n || t);
        }
        function v(t) {
          return (
            (function (t) {
              if (Array.isArray(t)) {
                return d(t);
              }
            })(t) ||
            (function (t) {
              if (
                ('undefined' !== typeof Symbol && null != t[Symbol.iterator]) ||
                null != t['@@iterator']
              ) {
                return Array.from(t);
              }
            })(t) ||
            (function (t, e) {
              if (!t) {
                return;
              }
              if ('string' === typeof t) {
                return d(t, e);
              }
              var n = Object.prototype.toString.call(t).slice(8, -1);
              'Object' === n && t.constructor && (n = t.constructor.name);
              if ('Map' === n || 'Set' === n) {
                return Array.from(t);
              }
              if ('Arguments' === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
                return d(t, e);
              }
            })(t) ||
            (function () {
              throw new TypeError(
                'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
              );
            })()
          );
        }
        function d(t, e) {
          (null == e || e > t.length) && (e = t.length);
          for (var n = 0, r = new Array(e); n < e; n++) {
            r[n] = t[n];
          }
          return r;
        }
        function y(t, e, n) {
          if (Number.isInteger(t)) {
            return t;
          }
          var r = Math.pow(10, e);
          return Math[n]((+t + Number.EPSILON) * r) / r;
        }
        Number.isInteger ||
          (Number.isInteger = function (t) {
            return 'number' === typeof t && isFinite(t) && Math.floor(t) === t;
          }),
          Number.EPSILON || (Number.EPSILON = 2220446049250313e-31);
        var g = p(Math.pow(10, -6));
        function p(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 6;
          return y(t, e, 'round');
        }
        function m(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : g;
          return Math.abs(t - e) < n;
        }
        p(Math.pow(10, -2)), p(Math.pow(10, -4));
        var b = Math.PI / 180;
        function w(t) {
          return t;
        }
        function k(t, e, n) {
          var r = 1 - n;
          return 3 * n * r * (t * r + e * n) + n * n * n;
        }
        function _() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
            e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1,
            r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1;
          return t < 0 || t > 1 || n < 0 || n > 1
            ? null
            : m(t, e) && m(n, r)
            ? w
            : function (i) {
                if (i <= 0) {
                  return t > 0 ? (i * e) / t : 0 === e && n > 0 ? (i * r) / n : 0;
                }
                if (i >= 1) {
                  return n < 1
                    ? 1 + ((i - 1) * (r - 1)) / (n - 1)
                    : 1 === n && t < 1
                    ? 1 + ((i - 1) * (e - 1)) / (t - 1)
                    : 1;
                }
                for (var o, u = 0, a = 1; u < a; ) {
                  var l = k(t, n, (o = (u + a) / 2));
                  if (m(i, l)) {
                    break;
                  }
                  l < i ? (u = o) : (a = o);
                }
                return k(e, r, o);
              };
        }
        function A() {
          return 1;
        }
        function x(t) {
          return 1 === t ? 1 : 0;
        }
        function O() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1,
            e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
          if (1 === t) {
            if (0 === e) {
              return x;
            }
            if (1 === e) {
              return A;
            }
          }
          var n = 1 / t;
          return function (t) {
            return t >= 1 ? 1 : (t += e * n) - (t % n);
          };
        }
        var S = Math.sin,
          E = Math.cos,
          j = Math.acos,
          M = Math.asin,
          P = Math.tan,
          B = Math.atan2,
          I = Math.PI / 180,
          T = 180 / Math.PI,
          N = Math.sqrt,
          R = (function () {
            function t() {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1,
                n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
                i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
                o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1,
                u = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0,
                a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0;
              r(this, t),
                (this.m = [e, n, i, o, u, a]),
                (this.i = null),
                (this.w = null),
                (this.s = null);
            }
            return (
              o(
                t,
                [
                  {
                    key: 'determinant',
                    get: function () {
                      var t = this.m;
                      return t[0] * t[3] - t[1] * t[2];
                    }
                  },
                  {
                    key: 'isIdentity',
                    get: function () {
                      if (null === this.i) {
                        var t = this.m;
                        this.i =
                          1 === t[0] &&
                          0 === t[1] &&
                          0 === t[2] &&
                          1 === t[3] &&
                          0 === t[4] &&
                          0 === t[5];
                      }
                      return this.i;
                    }
                  },
                  {
                    key: 'point',
                    value: function (t, e) {
                      var n = this.m;
                      return { x: n[0] * t + n[2] * e + n[4], y: n[1] * t + n[3] * e + n[5] };
                    }
                  },
                  {
                    key: 'translateSelf',
                    value: function () {
                      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
                        e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                      if (!t && !e) {
                        return this;
                      }
                      var n = this.m;
                      return (
                        (n[4] += n[0] * t + n[2] * e),
                        (n[5] += n[1] * t + n[3] * e),
                        (this.w = this.s = this.i = null),
                        this
                      );
                    }
                  },
                  {
                    key: 'rotateSelf',
                    value: function () {
                      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
                      if ((t %= 360)) {
                        var e = S((t *= I)),
                          n = E(t),
                          r = this.m,
                          i = r[0],
                          o = r[1];
                        (r[0] = i * n + r[2] * e),
                          (r[1] = o * n + r[3] * e),
                          (r[2] = r[2] * n - i * e),
                          (r[3] = r[3] * n - o * e),
                          (this.w = this.s = this.i = null);
                      }
                      return this;
                    }
                  },
                  {
                    key: 'scaleSelf',
                    value: function () {
                      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1,
                        e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
                      if (1 !== t || 1 !== e) {
                        var n = this.m;
                        (n[0] *= t),
                          (n[1] *= t),
                          (n[2] *= e),
                          (n[3] *= e),
                          (this.w = this.s = this.i = null);
                      }
                      return this;
                    }
                  },
                  {
                    key: 'skewSelf',
                    value: function (t, e) {
                      if (((e %= 360), (t %= 360) || e)) {
                        var n = this.m,
                          r = n[0],
                          i = n[1],
                          o = n[2],
                          u = n[3];
                        t && ((t = P(t * I)), (n[2] += r * t), (n[3] += i * t)),
                          e && ((e = P(e * I)), (n[0] += o * e), (n[1] += u * e)),
                          (this.w = this.s = this.i = null);
                      }
                      return this;
                    }
                  },
                  {
                    key: 'resetSelf',
                    value: function () {
                      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1,
                        e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
                        n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
                        r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1,
                        i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0,
                        o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0,
                        u = this.m;
                      return (
                        (u[0] = t),
                        (u[1] = e),
                        (u[2] = n),
                        (u[3] = r),
                        (u[4] = i),
                        (u[5] = o),
                        (this.w = this.s = this.i = null),
                        this
                      );
                    }
                  },
                  {
                    key: 'recomposeSelf',
                    value: function () {
                      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
                        e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
                        n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
                        r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null,
                        i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : null;
                      return (
                        this.isIdentity || this.resetSelf(),
                        t && (t.x || t.y) && this.translateSelf(t.x, t.y),
                        e && this.rotateSelf(e),
                        n && (n.x && this.skewSelf(n.x, 0), n.y && this.skewSelf(0, n.y)),
                        !r || (1 === r.x && 1 === r.y) || this.scaleSelf(r.x, r.y),
                        i && (i.x || i.y) && this.translateSelf(i.x, i.y),
                        this
                      );
                    }
                  },
                  {
                    key: 'decompose',
                    value: function () {
                      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
                        e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
                        n = this.m,
                        r = n[0] * n[0] + n[1] * n[1],
                        i = [
                          [n[0], n[1]],
                          [n[2], n[3]]
                        ],
                        o = N(r);
                      if (0 === o) {
                        return {
                          origin: { x: p(n[4]), y: p(n[5]) },
                          translate: { x: p(t), y: p(e) },
                          scale: { x: 0, y: 0 },
                          skew: { x: 0, y: 0 },
                          rotate: 0
                        };
                      }
                      (i[0][0] /= o), (i[0][1] /= o);
                      var u = n[0] * n[3] - n[1] * n[2] < 0;
                      u && (o = -o);
                      var a = i[0][0] * i[1][0] + i[0][1] * i[1][1];
                      (i[1][0] -= i[0][0] * a), (i[1][1] -= i[0][1] * a);
                      var l = N(i[1][0] * i[1][0] + i[1][1] * i[1][1]);
                      if (0 === l) {
                        return {
                          origin: { x: p(n[4]), y: p(n[5]) },
                          translate: { x: p(t), y: p(e) },
                          scale: { x: p(o), y: 0 },
                          skew: { x: 0, y: 0 },
                          rotate: 0
                        };
                      }
                      (i[1][0] /= l), (i[1][1] /= l), (a /= l);
                      var s = 0;
                      return (
                        i[1][1] < 0
                          ? ((s = j(i[1][1]) * T), i[0][1] < 0 && (s = 360 - s))
                          : (s = M(i[0][1]) * T),
                        u && (s = -s),
                        (a = B(a, N(i[0][0] * i[0][0] + i[0][1] * i[0][1])) * T),
                        u && (a = -a),
                        {
                          origin: { x: p(n[4]), y: p(n[5]) },
                          translate: { x: p(t), y: p(e) },
                          scale: { x: p(o), y: p(l) },
                          skew: { x: p(a), y: 0 },
                          rotate: p(s)
                        }
                      );
                    }
                  },
                  {
                    key: 'clone',
                    value: function () {
                      var t = this.m;
                      return new this.constructor(t[0], t[1], t[2], t[3], t[4], t[5]);
                    }
                  },
                  {
                    key: 'toString',
                    value: function () {
                      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ' ';
                      if (null === this.s) {
                        var e = this.m.map(function (t) {
                          return p(t);
                        });
                        1 === e[0] && 0 === e[1] && 0 === e[2] && 1 === e[3]
                          ? (this.s = 'translate(' + e[4] + t + e[5] + ')')
                          : (this.s = 'matrix(' + e.join(t) + ')');
                      }
                      return this.s;
                    }
                  }
                ],
                [
                  {
                    key: 'create',
                    value: function (t) {
                      return t
                        ? Array.isArray(t)
                          ? f(this, v(t))
                          : t instanceof this
                          ? t.clone()
                          : new this().recomposeSelf(
                              t.origin,
                              t.rotate,
                              t.skew,
                              t.scale,
                              t.translate
                            )
                        : new this();
                    }
                  }
                ]
              ),
              t
            );
          })();
        function F(t, e, n) {
          return t >= 0.5 ? n : e;
        }
        function D(t, e, n) {
          return 0 === t || e === n ? e : t * (n - e) + e;
        }
        function C(t, e, n) {
          var r = D(t, e, n);
          return r <= 0 ? 0 : r;
        }
        function q(t, e, n) {
          var r = D(t, e, n);
          return r <= 0 ? 0 : r >= 1 ? 1 : r;
        }
        function L(t, e, n) {
          return 0 === t ? e : 1 === t ? n : { x: D(t, e.x, n.x), y: D(t, e.y, n.y) };
        }
        function V(t, e, n) {
          return 0 === t ? e : 1 === t ? n : { x: C(t, e.x, n.x), y: C(t, e.y, n.y) };
        }
        function G(t, e, n) {
          var r = (function (t, e, n) {
            return Math.round(D(t, e, n));
          })(t, e, n);
          return r <= 0 ? 0 : r >= 255 ? 255 : r;
        }
        function z(t, e, n) {
          return 0 === t
            ? e
            : 1 === t
            ? n
            : {
                r: G(t, e.r, n.r),
                g: G(t, e.g, n.g),
                b: G(t, e.b, n.b),
                a: D(t, null == e.a ? 1 : e.a, null == n.a ? 1 : n.a)
              };
        }
        function Y(t, e, n) {
          var r = e.length;
          if (r !== n.length) {
            return F(t, e, n);
          }
          for (var i = new Array(r), o = 0; o < r; o++) {
            i[o] = D(t, e[o], n[o]);
          }
          return i;
        }
        function U(t, e) {
          for (var n = [], r = 0; r < t; r++) {
            n.push(e);
          }
          return n;
        }
        function W(t, e) {
          if (--e <= 0) {
            return t;
          }
          var n = (t = Object.assign([], t)).length;
          do {
            for (var r = 0; r < n; r++) {
              t.push(t[r]);
            }
          } while (--e > 0);
          return t;
        }
        var $,
          H = (function () {
            function t(e) {
              r(this, t), (this.list = e), (this.length = e.length);
            }
            return (
              o(t, [
                {
                  key: 'setAttribute',
                  value: function (t, e) {
                    for (var n = this.list, r = 0; r < this.length; r++) {
                      n[r].setAttribute(t, e);
                    }
                  }
                },
                {
                  key: 'removeAttribute',
                  value: function (t) {
                    for (var e = this.list, n = 0; n < this.length; n++) {
                      e[n].removeAttribute(t);
                    }
                  }
                },
                {
                  key: 'style',
                  value: function (t, e) {
                    for (var n = this.list, r = 0; r < this.length; r++) {
                      n[r].style[t] = e;
                    }
                  }
                }
              ]),
              t
            );
          })(),
          Q = /-./g,
          X = function (t, e) {
            return e.toUpperCase();
          };
        function J(t) {
          return 'function' === typeof t ? t : F;
        }
        function K(t) {
          return t
            ? 'function' === typeof t
              ? t
              : Array.isArray(t)
              ? (function (t) {
                  var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : w;
                  if (!Array.isArray(t)) {
                    return e;
                  }
                  switch (t.length) {
                    case 1:
                      return O(t[0]) || e;
                    case 2:
                      return O(t[0], t[1]) || e;
                    case 4:
                      return _(t[0], t[1], t[2], t[3]) || e;
                  }
                  return e;
                })(t, null)
              : (function (t, e) {
                  var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : w;
                  switch (t) {
                    case 'linear':
                      return w;
                    case 'steps':
                      return O(e.steps || 1, e.jump || 0) || n;
                    case 'bezier':
                    case 'cubic-bezier':
                      return _(e.x1 || 0, e.y1 || 0, e.x2 || 0, e.y2 || 0) || n;
                  }
                  return n;
                })(t.type, t.value, null)
            : null;
        }
        function Z(t, e, n) {
          var r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
            i = e.length - 1;
          if (t <= e[0].t) {
            return r ? [0, 0, e[0].v] : e[0].v;
          }
          if (t >= e[i].t) {
            return r ? [i, 1, e[i].v] : e[i].v;
          }
          var o,
            u = e[0],
            a = null;
          for (o = 1; o <= i; o++) {
            if (!(t > e[o].t)) {
              a = e[o];
              break;
            }
            u = e[o];
          }
          return null == a
            ? r
              ? [i, 1, e[i].v]
              : e[i].v
            : u.t === a.t
            ? r
              ? [o, 1, a.v]
              : a.v
            : ((t = (t - u.t) / (a.t - u.t)),
              u.e && (t = u.e(t)),
              r ? [o, t, n(t, u.v, a.v)] : n(t, u.v, a.v));
        }
        function tt(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
          return t && t.length
            ? 'function' !== typeof e
              ? null
              : ('function' !== typeof n && (n = null),
                function (r) {
                  var i = Z(r, t, e);
                  return null != i && n && (i = n(i)), i;
                })
            : null;
        }
        function et(t, e) {
          return t.t - e.t;
        }
        function nt(t, e, r, i, o) {
          var u,
            a = '@' === r[0],
            l = '#' === r[0],
            s = $[r],
            f = F;
          switch ((a ? ((u = r.substr(1)), (r = u.replace(Q, X))) : l && (r = r.substr(1)), n(s))) {
            case 'function':
              if (((f = s(i, o, Z, K, r, a, e, t)), l)) {
                return f;
              }
              break;
            case 'string':
              f = tt(i, J(s));
              break;
            case 'object':
              if ((f = tt(i, J(s.i), s.f)) && 'function' === typeof s.u) {
                return s.u(e, f, r, a, t);
              }
          }
          return f
            ? (function (t, e, n) {
                if (arguments.length > 3 && void 0 !== arguments[3] && arguments[3]) {
                  return t instanceof H
                    ? function (r) {
                        return t.style(e, n(r));
                      }
                    : function (r) {
                        return (t.style[e] = n(r));
                      };
                }
                if (Array.isArray(e)) {
                  var r = e.length;
                  return function (i) {
                    var o = n(i);
                    if (null == o) {
                      for (var u = 0; u < r; u++) {
                        t[u].removeAttribute(e);
                      }
                    } else {
                      for (var a = 0; a < r; a++) {
                        t[a].setAttribute(e, o);
                      }
                    }
                  };
                }
                return function (r) {
                  var i = n(r);
                  null == i ? t.removeAttribute(e) : t.setAttribute(e, i);
                };
              })(e, r, f, a)
            : null;
        }
        function rt(t, e, r, i) {
          if (!i || 'object' !== n(i)) {
            return null;
          }
          var o = null,
            u = null;
          return (
            Array.isArray(i)
              ? (u = (function (t) {
                  if (!t || !t.length) {
                    return null;
                  }
                  for (var e = 0; e < t.length; e++) {
                    t[e].e && (t[e].e = K(t[e].e));
                  }
                  return t.sort(et);
                })(i))
              : ((u = i.keys), (o = i.data || null)),
            u ? nt(t, e, r, u, o) : null
          );
        }
        function it(t, e, n) {
          if (!n) {
            return null;
          }
          var r = [];
          for (var i in n) {
            if (n.hasOwnProperty(i)) {
              var o = rt(t, e, i, n[i]);
              o && r.push(o);
            }
          }
          return r.length ? r : null;
        }
        function ot(t, e) {
          if (!e.settings.duration || e.settings.duration < 0) {
            return null;
          }
          var n,
            r,
            i,
            o,
            u,
            a = (function (t, e) {
              if (!e) {
                return null;
              }
              var n = [];
              if (Array.isArray(e)) {
                for (var r = e.length, i = 0; i < r; i++) {
                  var o = e[i];
                  if (2 === o.length) {
                    var u = null;
                    if ('string' === typeof o[0]) {
                      u = t.getElementById(o[0]);
                    } else if (Array.isArray(o[0])) {
                      u = [];
                      for (var a = 0; a < o[0].length; a++) {
                        if ('string' === typeof o[0][a]) {
                          var l = t.getElementById(o[0][a]);
                          l && u.push(l);
                        }
                      }
                      u = u.length ? (1 === u.length ? u[0] : new H(u)) : null;
                    }
                    if (u) {
                      var s = it(t, u, o[1]);
                      s && (n = n.concat(s));
                    }
                  }
                }
              } else {
                for (var f in e) {
                  if (e.hasOwnProperty(f)) {
                    var c = t.getElementById(f);
                    if (c) {
                      var h = it(t, c, e[f]);
                      h && (n = n.concat(h));
                    }
                  }
                }
              }
              return n.length ? n : null;
            })(t, e.elements);
          return a
            ? ((n = a),
              (r = e.settings),
              (i = r.duration),
              (o = n.length),
              (u = null),
              function (t, e) {
                var a = r.iterations || 1 / 0,
                  l = (r.alternate && a % 2 == 0) ^ (r.direction > 0) ? i : 0,
                  s = t % i,
                  f = 1 + (t - s) / i;
                (e *= r.direction), r.alternate && f % 2 == 0 && (e = -e);
                var c = !1;
                if (f > a) {
                  (s = l), (c = !0), -1 === r.fill && (s = r.direction > 0 ? 0 : i);
                } else if ((e < 0 && (s = i - s), s === u)) {
                  return !1;
                }
                u = s;
                for (var h = 0; h < o; h++) {
                  n[h](s);
                }
                return c;
              })
            : null;
        }
        function ut(t, e) {
          for (var n = e.querySelectorAll('svg'), r = 0; r < n.length; r++) {
            if (n[r].id === t.root && !n[r].svgatorAnimation) {
              return (n[r].svgatorAnimation = !0), n[r];
            }
          }
          return null;
        }
        function at(t) {
          var e = function (t) {
            return t.shadowRoot;
          };
          return document
            ? Array.from(
                t.querySelectorAll(
                  ':not(' +
                    [
                      'a',
                      'area',
                      'audio',
                      'br',
                      'canvas',
                      'circle',
                      'datalist',
                      'embed',
                      'g',
                      'head',
                      'hr',
                      'iframe',
                      'img',
                      'input',
                      'link',
                      'object',
                      'path',
                      'polygon',
                      'rect',
                      'script',
                      'source',
                      'style',
                      'svg',
                      'title',
                      'track',
                      'video'
                    ].join() +
                    ')'
                )
              )
                .filter(e)
                .map(e)
            : [];
        }
        function lt(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : document,
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
            r = ut(t, e);
          if (r) {
            return r;
          }
          if (n >= 20) {
            return null;
          }
          for (var i = at(e), o = 0; o < i.length; o++) {
            var u = lt(t, i[o], n + 1);
            if (u) {
              return u;
            }
          }
          return null;
        }
        function st(t, e) {
          if ((($ = e), !t || !t.root || !Array.isArray(t.animations))) {
            return null;
          }
          var n = lt(t);
          if (!n) {
            return null;
          }
          var r = t.animations
            .map(function (t) {
              return ot(n, t);
            })
            .filter(function (t) {
              return !!t;
            });
          return r.length
            ? {
                svg: n,
                animations: r,
                animationSettings: t.animationSettings,
                options: t.options || void 0
              }
            : null;
        }
        function ft(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : Number,
            r =
              arguments.length > 3 && void 0 !== arguments[3]
                ? arguments[3]
                : 'undefined' !== typeof BigInt && BigInt,
            i = '0x' + (t.replace(/[^0-9a-fA-F]+/g, '') || 27);
          return e && r && n.isSafeInteger && !n.isSafeInteger(+i) ? (n(r(i)) % e) + e : +i;
        }
        function ct(t, e, n) {
          return !t || !n || e > t.length ? t : t.substring(0, e) + ct(t.substring(e + 1), n, n);
        }
        function ht(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 27;
          return !t || t % e ? t % e : [0, 1].includes(e) ? e : ht(t / e, e);
        }
        function vt(t, e, n) {
          if (t && t.length) {
            var r = ft(n),
              i = ht(r) + 5,
              o = ct(t, ht(r, 5), i);
            return (
              (o = o.replace(/\x7c$/g, '==').replace(/\x2f$/g, '=')),
              (o = (function (t, e, n) {
                var r = +('0x' + t.substring(0, 4));
                t = t.substring(4);
                for (var i = (ft(e, r) % r) + (n % 27), o = [], u = 0; u < t.length; u += 2) {
                  if ('|' !== t[u]) {
                    var a = +('0x' + t[u] + t[u + 1]) - i;
                    o.push(a);
                  } else {
                    var l = +('0x' + t.substring(u + 1, u + 1 + 4)) - i;
                    (u += 3), o.push(l);
                  }
                }
                return String.fromCharCode.apply(String, o);
              })((o = (o = atob(o)).replace(/[\x41-\x5A]/g, '')), e, r)),
              (o = JSON.parse(o))
            );
          }
        }
        var dt = [
            { key: 'alternate', def: !1 },
            { key: 'fill', def: 1 },
            { key: 'iterations', def: 0 },
            { key: 'direction', def: 1 },
            { key: 'speed', def: 1 },
            { key: 'fps', def: 100 }
          ],
          yt = (function () {
            function t(e, n) {
              var i = this,
                o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
              r(this, t),
                (this._id = 0),
                (this._running = !1),
                (this._rollingBack = !1),
                (this._animations = e),
                (this._settings = n),
                (!o || o < '2022-05-02') && delete this._settings.speed,
                dt.forEach(function (t) {
                  i._settings[t.key] = i._settings[t.key] || t.def;
                }),
                (this.duration = n.duration),
                (this.offset = n.offset || 0),
                (this.rollbackStartOffset = 0);
            }
            return (
              o(
                t,
                [
                  {
                    key: 'alternate',
                    get: function () {
                      return this._settings.alternate;
                    }
                  },
                  {
                    key: 'fill',
                    get: function () {
                      return this._settings.fill;
                    }
                  },
                  {
                    key: 'iterations',
                    get: function () {
                      return this._settings.iterations;
                    }
                  },
                  {
                    key: 'direction',
                    get: function () {
                      return this._settings.direction;
                    }
                  },
                  {
                    key: 'speed',
                    get: function () {
                      return this._settings.speed;
                    }
                  },
                  {
                    key: 'fps',
                    get: function () {
                      return this._settings.fps;
                    }
                  },
                  {
                    key: 'maxFiniteDuration',
                    get: function () {
                      return this.iterations > 0 ? this.iterations * this.duration : this.duration;
                    }
                  },
                  {
                    key: '_apply',
                    value: function (t) {
                      for (
                        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                          n = this._animations,
                          r = n.length,
                          i = 0,
                          o = 0;
                        o < r;
                        o++
                      ) {
                        e[o] ? i++ : ((e[o] = n[o](t, 1)), e[o] && i++);
                      }
                      return i;
                    }
                  },
                  {
                    key: '_rollback',
                    value: function (t) {
                      var e = this,
                        n = 1 / 0,
                        r = null;
                      (this.rollbackStartOffset = t),
                        (this._rollingBack = !0),
                        (this._running = !0);
                      this._id = window.requestAnimationFrame(function i(o) {
                        if (e._rollingBack) {
                          null == r && (r = o);
                          var u = Math.round(t - (o - r) * e.speed);
                          if (u > e.duration && n !== 1 / 0) {
                            var a = !!e.alternate && (u / e.duration) % 2 > 1,
                              l = u % e.duration;
                            u = (l += a ? e.duration : 0) || e.duration;
                          }
                          var s = (e.fps ? 1e3 / e.fps : 0) * e.speed,
                            f = Math.max(0, u);
                          f <= n - s && ((e.offset = f), (n = f), e._apply(f));
                          var c = e.iterations > 0 && -1 === e.fill && u >= e.maxFiniteDuration;
                          (u <= 0 || e.offset < u || c) && e.stop(),
                            (e._id = window.requestAnimationFrame(i));
                        }
                      });
                    }
                  },
                  {
                    key: '_start',
                    value: function () {
                      var t = this,
                        e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
                        n = -1 / 0,
                        r = null,
                        i = {};
                      this._running = !0;
                      var o = function o(u) {
                        null == r && (r = u);
                        var a = Math.round((u - r) * t.speed + e),
                          l = (t.fps ? 1e3 / t.fps : 0) * t.speed;
                        if (
                          a >= n + l &&
                          !t._rollingBack &&
                          ((t.offset = a), (n = a), t._apply(a, i) === t._animations.length)
                        ) {
                          return void t.pause(!0);
                        }
                        t._id = window.requestAnimationFrame(o);
                      };
                      this._id = window.requestAnimationFrame(o);
                    }
                  },
                  {
                    key: '_pause',
                    value: function () {
                      this._id && window.cancelAnimationFrame(this._id), (this._running = !1);
                    }
                  },
                  {
                    key: 'play',
                    value: function () {
                      if (!this._running) {
                        return this._rollingBack
                          ? this._rollback(this.offset)
                          : this._start(this.offset);
                      }
                    }
                  },
                  {
                    key: 'stop',
                    value: function () {
                      this._pause(),
                        (this.offset = 0),
                        (this.rollbackStartOffset = 0),
                        (this._rollingBack = !1),
                        this._apply(0);
                    }
                  },
                  {
                    key: 'reachedToEnd',
                    value: function () {
                      return this.iterations > 0 && this.offset >= this.iterations * this.duration;
                    }
                  },
                  {
                    key: 'restart',
                    value: function () {
                      var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                      this.stop(t), this.play(t);
                    }
                  },
                  {
                    key: 'pause',
                    value: function () {
                      this._pause();
                    }
                  },
                  {
                    key: 'reverse',
                    value: function () {
                      this.direction = -this.direction;
                    }
                  }
                ],
                [
                  {
                    key: 'build',
                    value: function (t, e) {
                      delete t.animationSettings,
                        (t.options = vt(t.options, t.root, '91c80d77')),
                        t.animations.map(function (e) {
                          (e.settings = vt(e.s, t.root, '91c80d77')),
                            delete e.s,
                            t.animationSettings || (t.animationSettings = e.settings);
                        });
                      var n = t.version;
                      if (!(t = st(t, e))) {
                        return null;
                      }
                      var r = t.options || {},
                        i = new this(t.animations, t.animationSettings, n);
                      return { el: t.svg, options: r, player: i };
                    }
                  },
                  {
                    key: 'push',
                    value: function (t) {
                      return this.build(t);
                    }
                  },
                  {
                    key: 'init',
                    value: function () {
                      var t = this,
                        e = window.__SVGATOR_PLAYER__ && window.__SVGATOR_PLAYER__['91c80d77'];
                      Array.isArray(e) &&
                        e.splice(0).forEach(function (e) {
                          return t.build(e);
                        });
                    }
                  }
                ]
              ),
              t
            );
          })();
        !(function () {
          for (
            var t = 0, e = ['ms', 'moz', 'webkit', 'o'], n = 0;
            n < e.length && !window.requestAnimationFrame;
            ++n
          ) {
            (window.requestAnimationFrame = window[e[n] + 'RequestAnimationFrame']),
              (window.cancelAnimationFrame =
                window[e[n] + 'CancelAnimationFrame'] ||
                window[e[n] + 'CancelRequestAnimationFrame']);
          }
          window.requestAnimationFrame ||
            ((window.requestAnimationFrame = function (e) {
              var n = Date.now(),
                r = Math.max(0, 16 - (n - t)),
                i = window.setTimeout(function () {
                  e(n + r);
                }, r);
              return (t = n + r), i;
            }),
            (window.cancelAnimationFrame = window.clearTimeout));
        })();
        var gt = (function () {
          function t(e, n, i) {
            r(this, t);
            var o = (function (t) {
              var e,
                n,
                r,
                i =
                  t &&
                  1 ===
                    (null === (e = t.ownerDocument) ||
                    void 0 === e ||
                    null === (n = e.childNodes) ||
                    void 0 === n
                      ? void 0
                      : n.length) &&
                  window.parent !== window,
                o = { el: t, window: window };
              if (!i) {
                return o;
              }
              try {
                r = window.parent.document;
              } catch (t) {
                return o;
              }
              return (
                (o.window = window.parent),
                (o.el =
                  Array.from(r.querySelectorAll('iframe,object')).filter(function (t) {
                    return t.contentWindow === window;
                  })[0] || o.el),
                o
              );
            })(e);
            (n = Math.max(1, n || 1)),
              (n = Math.min(n, 100)),
              (this.el = o.el),
              (this._handlers = []),
              (this.onThresholdChange = i && i.call ? i : function () {}),
              (this.thresholdPercent = n || 1),
              (this.currentVisibility = null),
              (this.visibilityCalculator = (function (t, e) {
                var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : n,
                  r = !1,
                  i = null,
                  o = function () {
                    for (
                      var o = 0, u = n.innerHeight, a = 0, l = n.innerWidth, s = t.parentNode;
                      s instanceof Element;

                    ) {
                      var f = n.getComputedStyle(s);
                      if ('visible' !== f.overflowY || 'visible' !== f.overflowX) {
                        var c = s.getBoundingClientRect();
                        'visible' !== f.overflowY &&
                          ((o = Math.max(o, c.top)), (u = Math.min(u, c.bottom))),
                          'visible' !== f.overflowX &&
                            ((a = Math.max(a, c.left)), (l = Math.min(l, c.right)));
                      }
                      if (s === s.parentNode) {
                        break;
                      }
                      s = s.parentNode;
                    }
                    r = !1;
                    var h = t.getBoundingClientRect(),
                      v = Math.min(h.height, Math.max(0, o - h.top)),
                      d = Math.min(h.height, Math.max(0, h.bottom - u)),
                      y = Math.min(h.width, Math.max(0, a - h.left)),
                      g = Math.min(h.width, Math.max(0, h.right - l)),
                      p = (h.height - v - d) / h.height,
                      m = (h.width - y - g) / h.width,
                      b = Math.round(p * m * 100);
                    (null !== i && i === b) || ((i = b), e(b));
                  };
                return function (t) {
                  r && clearTimeout(r),
                    (r = setTimeout(function () {
                      return o();
                    }, 100));
                };
              })(this.el, this.onVisibilityUpdate.bind(this), o.window)),
              this.bindScrollWatchers(),
              this.visibilityCalculator();
          }
          return (
            o(t, [
              {
                key: 'bindScrollWatchers',
                value: function () {
                  for (
                    var t = this.el.parentNode;
                    t &&
                    (this._handlers.push({
                      element: t,
                      event: 'scroll',
                      handler: this.visibilityCalculator
                    }),
                    t.addEventListener('scroll', this.visibilityCalculator),
                    t !== t.parentNode && t !== document);

                  ) {
                    t = t.parentNode;
                  }
                }
              },
              {
                key: 'onVisibilityUpdate',
                value: function (t) {
                  var e = this.currentVisibility >= this.thresholdPercent,
                    n = t >= this.thresholdPercent;
                  if (null === this.currentVisibility || e !== n) {
                    return (this.currentVisibility = t), void this.onThresholdChange(n);
                  }
                  this.currentVisibility = t;
                }
              },
              {
                key: 'destruct',
                value: function () {
                  this._handlers.forEach(function (t) {
                    t.element.removeEventListener(t.event, t.handler);
                  });
                }
              }
            ]),
            t
          );
        })();
        function pt(t) {
          return p(t) + '';
        }
        function mt(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ' ';
          return t && t.length ? t.map(pt).join(e) : '';
        }
        function bt(t) {
          return pt(t.x) + ',' + pt(t.y);
        }
        function wt(t) {
          if (!t) {
            return 'transparent';
          }
          if (null == t.a || t.a >= 1) {
            var e = function (t) {
                return 1 === (t = parseInt(t).toString(16)).length ? '0' + t : t;
              },
              n = function (t) {
                return t.charAt(0) === t.charAt(1);
              },
              r = e(t.r),
              i = e(t.g),
              o = e(t.b);
            return (
              n(r) && n(i) && n(o) && ((r = r.charAt(0)), (i = i.charAt(0)), (o = o.charAt(0))),
              '#' + r + i + o
            );
          }
          return 'rgba(' + t.r + ',' + t.g + ',' + t.b + ',' + t.a + ')';
        }
        function kt(t) {
          return t ? 'url(#' + t + ')' : 'none';
        }
        var _t = {
            f: null,
            i: V,
            u: function (t, e) {
              return function (n) {
                var r = e(n);
                t.setAttribute('rx', pt(r.x)), t.setAttribute('ry', pt(r.y));
              };
            }
          },
          At = {
            f: null,
            i: function (t, e, n) {
              return 0 === t
                ? e
                : 1 === t
                ? n
                : { width: C(t, e.width, n.width), height: C(t, e.height, n.height) };
            },
            u: function (t, e) {
              return function (n) {
                var r = e(n);
                t.setAttribute('width', pt(r.width)), t.setAttribute('height', pt(r.height));
              };
            }
          };
        Object.freeze({ M: 2, L: 2, Z: 0, H: 1, V: 1, C: 6, Q: 4, T: 2, S: 4, A: 7 });
        var xt = {},
          Ot = null;
        function St(t) {
          var e = (function () {
            if (Ot) {
              return Ot;
            }
            if (
              'object' !== ('undefined' === typeof document ? 'undefined' : n(document)) ||
              !document.createElementNS
            ) {
              return {};
            }
            var t = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            return t && t.style
              ? ((t.style.position = 'absolute'),
                (t.style.opacity = '0.01'),
                (t.style.zIndex = '-9999'),
                (t.style.left = '-9999px'),
                (t.style.width = '1px'),
                (t.style.height = '1px'),
                (Ot = { svg: t }))
              : {};
          })().svg;
          if (!e) {
            return function (t) {
              return null;
            };
          }
          var r = document.createElementNS(e.namespaceURI, 'path');
          r.setAttributeNS(null, 'd', t),
            r.setAttributeNS(null, 'fill', 'none'),
            r.setAttributeNS(null, 'stroke', 'none'),
            e.appendChild(r);
          var i = r.getTotalLength();
          return function (t) {
            var e = r.getPointAtLength(i * t);
            return { x: e.x, y: e.y };
          };
        }
        function Et(t) {
          return xt[t] ? xt[t] : (xt[t] = St(t));
        }
        function jt(t, e, n, r) {
          if (!t || !r) {
            return !1;
          }
          var i = ['M', t.x, t.y];
          if (
            (e && n && (i.push('C'), i.push(e.x), i.push(e.y), i.push(n.x), i.push(n.y)),
            e ? !n : n)
          ) {
            var o = e || n;
            i.push('Q'), i.push(o.x), i.push(o.y);
          }
          return e || n || i.push('L'), i.push(r.x), i.push(r.y), i.join(' ');
        }
        function Mt(t, e, n, r) {
          var i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 1,
            o = jt(t, e, n, r),
            u = Et(o);
          try {
            return u(i);
          } catch (t) {
            return null;
          }
        }
        function Pt(t, e, n) {
          return t + (e - t) * n;
        }
        function Bt(t, e, n) {
          var r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
            i = { x: Pt(t.x, e.x, n), y: Pt(t.y, e.y, n) };
          return r && (i.a = It(t, e)), i;
        }
        function It(t, e) {
          return Math.atan2(e.y - t.y, e.x - t.x);
        }
        function Tt(t, e, n, r) {
          var i = 1 - r;
          return i * i * t + 2 * i * r * e + r * r * n;
        }
        function Nt(t, e, n, r) {
          return 2 * (1 - r) * (e - t) + 2 * r * (n - e);
        }
        function Rt(t, e, n, r) {
          var i = arguments.length > 4 && void 0 !== arguments[4] && arguments[4],
            o = Mt(t, e, null, n, r);
          return (
            o || (o = { x: Tt(t.x, e.x, n.x, r), y: Tt(t.y, e.y, n.y, r) }),
            i && (o.a = Ft(t, e, n, r)),
            o
          );
        }
        function Ft(t, e, n, r) {
          return Math.atan2(Nt(t.y, e.y, n.y, r), Nt(t.x, e.x, n.x, r));
        }
        function Dt(t, e, n, r, i) {
          var o = i * i;
          return i * o * (r - t + 3 * (e - n)) + 3 * o * (t + n - 2 * e) + 3 * i * (e - t) + t;
        }
        function Ct(t, e, n, r, i) {
          var o = 1 - i;
          return 3 * (o * o * (e - t) + 2 * o * i * (n - e) + i * i * (r - n));
        }
        function qt(t, e, n, r, i) {
          var o = arguments.length > 5 && void 0 !== arguments[5] && arguments[5],
            u = Mt(t, e, n, r, i);
          return (
            u || (u = { x: Dt(t.x, e.x, n.x, r.x, i), y: Dt(t.y, e.y, n.y, r.y, i) }),
            o && (u.a = Lt(t, e, n, r, i)),
            u
          );
        }
        function Lt(t, e, n, r, i) {
          return Math.atan2(Ct(t.y, e.y, n.y, r.y, i), Ct(t.x, e.x, n.x, r.x, i));
        }
        function Vt(t, e, n) {
          var r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
          if (zt(e)) {
            if (Yt(n)) {
              return Rt(e, n.start, n, t, r);
            }
          } else if (zt(n)) {
            if (Ut(e)) {
              return Rt(e, e.end, n, t, r);
            }
          } else {
            if (Ut(e)) {
              return Yt(n) ? qt(e, e.end, n.start, n, t, r) : Rt(e, e.end, n, t, r);
            }
            if (Yt(n)) {
              return Rt(e, n.start, n, t, r);
            }
          }
          return Bt(e, n, t, r);
        }
        function Gt(t, e, n) {
          var r = Vt(t, e, n, !0);
          return (
            (r.a =
              (function (t) {
                return arguments.length > 1 && void 0 !== arguments[1] && arguments[1]
                  ? t + Math.PI
                  : t;
              })(r.a) / b),
            r
          );
        }
        function zt(t) {
          return !t.type || 'corner' === t.type;
        }
        function Yt(t) {
          return null != t.start && !zt(t);
        }
        function Ut(t) {
          return null != t.end && !zt(t);
        }
        var Wt = new R();
        var $t = {
            f: function (t) {
              return t ? t.join(' ') : '';
            },
            i: function (t, e, r) {
              if (0 === t) {
                return e;
              }
              if (1 === t) {
                return r;
              }
              var i = e.length;
              if (i !== r.length) {
                return F(t, e, r);
              }
              for (var o, u = new Array(i), a = 0; a < i; a++) {
                if ((o = n(e[a])) !== n(r[a])) {
                  return F(t, e, r);
                }
                if ('number' === o) {
                  u[a] = D(t, e[a], r[a]);
                } else {
                  if (e[a] !== r[a]) {
                    return F(t, e, r);
                  }
                  u[a] = e[a];
                }
              }
              return u;
            }
          },
          Ht = {
            f: null,
            i: Y,
            u: function (t, e) {
              return function (n) {
                var r = e(n);
                t.setAttribute('x1', pt(r[0])),
                  t.setAttribute('y1', pt(r[1])),
                  t.setAttribute('x2', pt(r[2])),
                  t.setAttribute('y2', pt(r[3]));
              };
            }
          },
          Qt = { f: pt, i: D },
          Xt = { f: pt, i: q },
          Jt = {
            f: function (t) {
              var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ' ';
              return (
                t &&
                  t.length > 0 &&
                  (t = t.map(function (t) {
                    return p(t, 4);
                  })),
                mt(t, e)
              );
            },
            i: function (t, e, n) {
              var r,
                i,
                o,
                u = e.length,
                a = n.length;
              if (u !== a) {
                if (0 === u) {
                  e = U((u = a), 0);
                } else if (0 === a) {
                  (a = u), (n = U(u, 0));
                } else {
                  var l =
                    (o =
                      ((r = u) * (i = a)) /
                      (function (t, e) {
                        for (var n; e; ) {
                          (n = e), (e = t % e), (t = n);
                        }
                        return t || 1;
                      })(r, i)) < 0
                      ? -o
                      : o;
                  (e = W(e, Math.floor(l / u))), (n = W(n, Math.floor(l / a))), (u = a = l);
                }
              }
              for (var s = [], f = 0; f < u; f++) {
                s.push(p(C(t, e[f], n[f])));
              }
              return s;
            }
          };
        function Kt(t, e, n) {
          return t.map(function (t) {
            return (function (t, e, n) {
              var r = t.v;
              if (!r || 'g' !== r.t || r.s || !r.v || !r.r) {
                return t;
              }
              var i = n.getElementById(r.r),
                o = (i && i.querySelectorAll('stop')) || [];
              return (
                (r.s = r.v.map(function (t, e) {
                  var n = o[e] && o[e].getAttribute('offset');
                  return { c: t, o: (n = p(parseInt(n) / 100)) };
                })),
                delete r.v,
                t
              );
            })(t, 0, n);
          });
        }
        var Zt = {
          gt: 'gradientTransform',
          c: { x: 'cx', y: 'cy' },
          rd: 'r',
          f: { x: 'x1', y: 'y1' },
          to: { x: 'x2', y: 'y2' }
        };
        function te(t, e, r, i, o, u, a, l) {
          return (
            Kt(t, 0, l),
            (e = (function (t, e, n) {
              for (var r, i, o, u = t.length - 1, a = {}, l = 0; l <= u; l++) {
                (r = t[l]).e && (r.e = e(r.e)),
                  r.v &&
                    'g' === (i = r.v).t &&
                    i.r &&
                    (o = n.getElementById(i.r)) &&
                    (a[i.r] = { e: o, s: o.querySelectorAll('stop') });
              }
              return a;
            })(t, i, l)),
            function (i) {
              var o = r(i, t, ee);
              if (!o) {
                return 'none';
              }
              if ('c' === o.t) {
                return wt(o.v);
              }
              if ('g' === o.t) {
                if (!e[o.r]) {
                  return kt(o.r);
                }
                var u = e[o.r];
                return (
                  (function (t, e) {
                    for (var n = t.s, r = n.length; r < e.length; r++) {
                      var i = n[n.length - 1].cloneNode();
                      (i.id = ie(i.id)),
                        t.e.appendChild(i),
                        (n = t.s = t.e.querySelectorAll('stop'));
                    }
                    for (var o = 0, u = n.length, a = e.length - 1; o < u; o++) {
                      n[o].setAttribute('stop-color', wt(e[Math.min(o, a)].c)),
                        n[o].setAttribute('offset', e[Math.min(o, a)].o);
                    }
                  })(u, o.s),
                  Object.keys(Zt).forEach(function (t) {
                    if (void 0 !== o[t]) {
                      if ('object' !== n(Zt[t])) {
                        var e,
                          r =
                            'gt' === t
                              ? ((e = o[t]), Array.isArray(e) ? 'matrix(' + e.join(' ') + ')' : '')
                              : o[t],
                          i = Zt[t];
                        u.e.setAttribute(i, r);
                      } else {
                        Object.keys(Zt[t]).forEach(function (e) {
                          if (void 0 !== o[t][e]) {
                            var n = o[t][e],
                              r = Zt[t][e];
                            u.e.setAttribute(r, n);
                          }
                        });
                      }
                    }
                  }),
                  kt(o.r)
                );
              }
              return 'none';
            }
          );
        }
        function ee(t, n, r) {
          if (0 === t) {
            return n;
          }
          if (1 === t) {
            return r;
          }
          if (n && r) {
            var i = n.t;
            if (i === r.t) {
              switch (n.t) {
                case 'c':
                  return { t: i, v: z(t, n.v, r.v) };
                case 'g':
                  if (n.r === r.r) {
                    var o = { t: i, s: ne(t, n.s, r.s), r: n.r };
                    return (
                      n.gt && r.gt && (o.gt = Y(t, n.gt, r.gt)),
                      n.c
                        ? ((o.c = L(t, n.c, r.c)), (o.rd = C(t, n.rd, r.rd)))
                        : n.f && ((o.f = L(t, n.f, r.f)), (o.to = L(t, n.to, r.to))),
                      o
                    );
                  }
              }
            }
            if (('c' === n.t && 'g' === r.t) || ('c' === r.t && 'g' === n.t)) {
              var u = 'c' === n.t ? n : r,
                a = 'g' === n.t ? e({}, n) : e({}, r),
                l = a.s.map(function (t) {
                  return { c: u.v, o: t.o };
                });
              return (a.s = 'c' === n.t ? ne(t, l, a.s) : ne(t, a.s, l)), a;
            }
          }
          return F(t, n, r);
        }
        function ne(t, e, n) {
          if (e.length === n.length) {
            return e.map(function (e, r) {
              return re(t, e, n[r]);
            });
          }
          for (var r = Math.max(e.length, n.length), i = [], o = 0; o < r; o++) {
            var u = re(t, e[Math.min(o, e.length - 1)], n[Math.min(o, n.length - 1)]);
            i.push(u);
          }
          return i;
        }
        function re(t, e, n) {
          return { o: q(t, e.o, n.o || 0), c: z(t, e.c, n.c || {}) };
        }
        function ie(t) {
          return t.replace(/-fill-([0-9]+)$/, function (t, e) {
            return '-fill-' + (+e + 1);
          });
        }
        function oe(t, e, n) {
          return 0 === t
            ? e
            : 1 === t
            ? n
            : {
                blur: V(t, e.blur, n.blur),
                offset: L(t, e.offset, n.offset),
                color: z(t, e.color, n.color)
              };
        }
        var ue = {
          blur: V,
          brightness: C,
          contrast: C,
          'drop-shadow': oe,
          'inner-shadow': oe,
          grayscale: C,
          'hue-rotate': D,
          invert: C,
          opacity: C,
          saturate: C,
          sepia: C
        };
        function ae(t, e, n) {
          if (0 === t) {
            return e;
          }
          if (1 === t) {
            return n;
          }
          var r = e.length;
          if (r !== n.length) {
            return F(t, e, n);
          }
          for (var i, o = [], u = 0; u < r; u++) {
            if (e[u].type !== n[u].type) {
              return e;
            }
            if (!(i = ue[e[u].type])) {
              return F(t, e, n);
            }
            o.push({ type: e.type, value: i(t, e[u].value, n[u].value) });
          }
          return o;
        }
        var le = {
          blur: function (t) {
            return t
              ? function (e) {
                  t.setAttribute('stdDeviation', bt(e));
                }
              : null;
          },
          brightness: function (t, e, n) {
            return (t = fe(n, e))
              ? function (e) {
                  (e = pt(e)),
                    t.map(function (t) {
                      return t.setAttribute('slope', e);
                    });
                }
              : null;
          },
          contrast: function (t, e, n) {
            return (t = fe(n, e))
              ? function (e) {
                  var n = pt((1 - e) / 2);
                  (e = pt(e)),
                    t.map(function (t) {
                      t.setAttribute('slope', e), t.setAttribute('intercept', n);
                    });
                }
              : null;
          },
          'drop-shadow': function (t, e, n) {
            var r = n.getElementById(e + '-blur');
            if (!r) {
              return null;
            }
            var i = n.getElementById(e + '-offset');
            if (!i) {
              return null;
            }
            var o = n.getElementById(e + '-flood');
            return o
              ? function (t) {
                  r.setAttribute('stdDeviation', bt(t.blur)),
                    i.setAttribute('dx', pt(t.offset.x)),
                    i.setAttribute('dy', pt(t.offset.y)),
                    o.setAttribute('flood-color', wt(t.color));
                }
              : null;
          },
          'inner-shadow': function (t, e, n) {
            var r = n.getElementById(e + '-blur');
            if (!r) {
              return null;
            }
            var i = n.getElementById(e + '-offset');
            if (!i) {
              return null;
            }
            var o = n.getElementById(e + '-color-matrix');
            return o
              ? function (t) {
                  r.setAttribute('stdDeviation', bt(t.blur)),
                    i.setAttribute('dx', pt(t.offset.x)),
                    i.setAttribute('dy', pt(t.offset.y));
                  var e = [
                    0,
                    0,
                    0,
                    0,
                    t.color.r / 255,
                    0,
                    0,
                    0,
                    0,
                    t.color.g / 255,
                    0,
                    0,
                    0,
                    0,
                    t.color.b / 255,
                    0,
                    0,
                    0,
                    t.color.a,
                    0
                  ];
                  o.setAttribute('values', mt(e));
                }
              : null;
          },
          grayscale: function (t) {
            return t
              ? function (e) {
                  t.setAttribute(
                    'values',
                    mt(
                      (function (t) {
                        return [
                          0.2126 + 0.7874 * (t = 1 - t),
                          0.7152 - 0.7152 * t,
                          0.0722 - 0.0722 * t,
                          0,
                          0,
                          0.2126 - 0.2126 * t,
                          0.7152 + 0.2848 * t,
                          0.0722 - 0.0722 * t,
                          0,
                          0,
                          0.2126 - 0.2126 * t,
                          0.7152 - 0.7152 * t,
                          0.0722 + 0.9278 * t,
                          0,
                          0,
                          0,
                          0,
                          0,
                          1,
                          0
                        ];
                      })(e)
                    )
                  );
                }
              : null;
          },
          'hue-rotate': function (t) {
            return t
              ? function (e) {
                  return t.setAttribute('values', pt(e));
                }
              : null;
          },
          invert: function (t, e, n) {
            return (t = fe(n, e))
              ? function (e) {
                  (e = pt(e) + ' ' + pt(1 - e)),
                    t.map(function (t) {
                      return t.setAttribute('tableValues', e);
                    });
                }
              : null;
          },
          opacity: function (t, e, n) {
            return (t = n.getElementById(e + '-A'))
              ? function (e) {
                  return t.setAttribute('tableValues', '0 ' + pt(e));
                }
              : null;
          },
          saturate: function (t) {
            return t
              ? function (e) {
                  return t.setAttribute('values', pt(e));
                }
              : null;
          },
          sepia: function (t) {
            return t
              ? function (e) {
                  return t.setAttribute(
                    'values',
                    mt(
                      (function (t) {
                        return [
                          0.393 + 0.607 * (t = 1 - t),
                          0.769 - 0.769 * t,
                          0.189 - 0.189 * t,
                          0,
                          0,
                          0.349 - 0.349 * t,
                          0.686 + 0.314 * t,
                          0.168 - 0.168 * t,
                          0,
                          0,
                          0.272 - 0.272 * t,
                          0.534 - 0.534 * t,
                          0.131 + 0.869 * t,
                          0,
                          0,
                          0,
                          0,
                          0,
                          1,
                          0
                        ];
                      })(e)
                    )
                  );
                }
              : null;
          }
        };
        var se = ['R', 'G', 'B'];
        function fe(t, e) {
          var n = se.map(function (n) {
            return t.getElementById(e + '-' + n) || null;
          });
          return -1 !== n.indexOf(null) ? null : n;
        }
        var ce = {
            fill: te,
            'fill-opacity': Xt,
            stroke: te,
            'stroke-opacity': Xt,
            'stroke-width': Qt,
            'stroke-dashoffset': { f: pt, i: D },
            'stroke-dasharray': Jt,
            opacity: Xt,
            transform: function (t, e, r, i) {
              if (
                !(t = (function (t, e) {
                  if (!t || 'object' !== n(t)) {
                    return null;
                  }
                  var r = !1;
                  for (var i in t) {
                    t.hasOwnProperty(i) &&
                      (t[i] && t[i].length
                        ? (t[i].forEach(function (t) {
                            t.e && (t.e = e(t.e));
                          }),
                          (r = !0))
                        : delete t[i]);
                  }
                  return r ? t : null;
                })(t, i))
              ) {
                return null;
              }
              var o = function (n, i, o) {
                var u = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
                return t[n] ? r(i, t[n], o) : e && e[n] ? e[n] : u;
              };
              return e && e.a && t.o
                ? function (e) {
                    var n = r(e, t.o, Gt);
                    return Wt.recomposeSelf(
                      n,
                      o('r', e, D, 0) + n.a,
                      o('k', e, L),
                      o('s', e, L),
                      o('t', e, L)
                    ).toString();
                  }
                : function (t) {
                    return Wt.recomposeSelf(
                      o('o', t, Vt, null),
                      o('r', t, D, 0),
                      o('k', t, L),
                      o('s', t, L),
                      o('t', t, L)
                    ).toString();
                  };
            },
            '#filter': function (t, e, n, r, i, o, u, a) {
              if (!e.items || !t || !t.length) {
                return null;
              }
              var l = (function (t, e) {
                var n = (t = t.map(function (t) {
                  return t && le[t[0]]
                    ? (e.getElementById(t[1]), le[t[0]](e.getElementById(t[1]), t[1], e))
                    : null;
                })).length;
                return function (e) {
                  for (var r = 0; r < n; r++) {
                    t[r] && t[r](e[r].value);
                  }
                };
              })(e.items, a);
              return l
                ? ((t = (function (t, e) {
                    return t.map(function (t) {
                      return (t.e = e(t.e)), t;
                    });
                  })(t, r)),
                  function (e) {
                    l(n(e, t, ae));
                  })
                : null;
            },
            '#line': Ht,
            points: { f: mt, i: Y },
            d: $t,
            r: Qt,
            '#size': At,
            '#radius': _t,
            _: function (t, e) {
              if (Array.isArray(t)) {
                for (var n = 0; n < t.length; n++) {
                  this[t[n]] = e;
                }
              } else {
                this[t] = e;
              }
            }
          },
          he = {
            currentTime: 'offset',
            duration: 'duration',
            hasEnded: function () {
              return this.reachedToEnd();
            },
            isAlternate: 'alternate',
            isPlaying: '_running',
            isRollingBack: '_rollingBack',
            state: function (t, e) {
              return e.isPlaying
                ? e.isRollingBack
                  ? 'rollback'
                  : 'playing'
                : e.hasEnded
                ? 'ended'
                : 'paused';
            },
            totalTime: 'maxFiniteDuration',
            iterations: 'iterations',
            direction: 'direction',
            fill: 'fill',
            isReversed: function (t, e) {
              return -1 === e.direction;
            },
            isBackwards: function (t, e) {
              return -1 === e.fill;
            },
            isInfinite: function (t, e) {
              return 0 === e.iterations;
            },
            speed: 'speed',
            fps: 'fps'
          },
          ve = {
            destruct: 'destruct',
            pause: 'pause',
            play: function (t, e) {
              return de(t, e.hasEnded ? 'restart' : 'play', e);
            },
            restart: 'restart',
            reverse: function (t, e) {
              return de(t, 'reverse', e, [!0]);
            },
            seek: 'seek',
            seekBy: 'seekBy',
            seekTo: 'seekTo',
            stop: 'stop',
            toggle: 'toggle',
            togglePlay: 'toggle',
            set: 'set'
          };
        function de(t, e, n) {
          var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : [];
          return function () {
            var i,
              o = Array.prototype.slice.call(arguments);
            return o.unshift.apply(o, v(r)), (i = t[e]).call.apply(i, [t].concat(v(o))), n;
          };
        }
        var ye = function t(e) {
          r(this, t);
          var n = {},
            i = ['on', 'off'],
            o = {
              get: function (t, e, r) {
                return he[e]
                  ? 'function' === typeof he[e]
                    ? he[e].call(t, t, r)
                    : t[he[e]]
                  : ve[e]
                  ? 'function' === typeof ve[e]
                    ? ve[e].call(t, t, r)
                    : de(t, ve[e], r)
                  : -1 !== i.indexOf(e)
                  ? n[e]
                  : 'ready' === e
                  ? function (t) {
                      return t && t.call(r, r), r;
                    }
                  : void 0;
              },
              set: function (t, e, r) {
                return -1 !== i.indexOf(e) && (n[e] = r);
              },
              ownKeys: function (t) {
                return Object.keys(he);
              },
              has: function (t, e) {
                return void 0 !== he[e];
              }
            };
          if ('function' === typeof Proxy) {
            return new Proxy(e, o);
          }
          var u = Object.keys(he).concat(Object.keys(ve)).concat(i),
            a = {};
          return (
            u.forEach(function (t) {
              var n = {
                enumerable: !1,
                configurable: !1,
                get: function () {
                  return o.get(e, t, a);
                }
              };
              -1 !== i.indexOf(t) &&
                (n.set = function (n) {
                  return o.set(e, t, n);
                }),
                Object.defineProperty(a, t, n);
            }),
            a
          );
        };
        function ge(t) {
          t || (t = this);
          var e = {};
          (this.on = function (t, n) {
            var r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
            return (
              'function' === typeof n &&
              (t.split(/[, ]+/g).forEach(function (t) {
                return (e[t] = e[t] || []), r ? e[t].unshift(n) : e[t].push(n);
              }),
              !0)
            );
          }),
            (this.off = function (t, n) {
              for (var r in e) {
                if (e.hasOwnProperty(r) && r.substr(0, t.length) === t) {
                  if (n) {
                    for (var i = 0; i < e[r].length; i++) {
                      e[r][i] === n && (e[r][i] = null);
                    }
                  } else {
                    e[r] = null;
                  }
                }
              }
            }),
            (this.trigger = function () {
              var n,
                r = Array.prototype.slice.call(arguments),
                i = r[0],
                o = r.slice(1);
              t: for (var u in e) {
                if (
                  e.hasOwnProperty(u) &&
                  e[u] &&
                  (u === i || u.substr(0, i.length + 1) === i + '.')
                ) {
                  for (var a = 0; a < (e[u] || []).length; a++) {
                    if (e[u][a] && !1 === (n = e[u][a].apply(t, o))) {
                      break t;
                    }
                  }
                }
              }
              return n;
            });
        }
        var pe = !0,
          me = ['iterations', 'speed', 'fps', 'direction', 'fill', 'alternate'],
          be = (function (t) {
            !(function (t, e) {
              if ('function' !== typeof e && null !== e) {
                throw new TypeError('Super expression must either be null or a function');
              }
              (t.prototype = Object.create(e && e.prototype, {
                constructor: { value: t, writable: !0, configurable: !0 }
              })),
                e && l(t, e);
            })(u, t);
            var e,
              n,
              i =
                ((e = u),
                (n = s()),
                function () {
                  var t,
                    r = a(e);
                  if (n) {
                    var i = a(this).constructor;
                    t = Reflect.construct(r, arguments, i);
                  } else {
                    t = r.apply(this, arguments);
                  }
                  return c(this, t);
                });
            function u(t, e) {
              var n,
                o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
              return r(this, u), ((n = i.call(this, t, e, o))._handlers = []), n;
            }
            return (
              o(
                u,
                [
                  {
                    key: '_adjustOffset',
                    value: function () {
                      var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                        e = this.alternate ? 2 * this.duration : this.duration;
                      if (t) {
                        if (!this._rollingBack && 0 === this.offset) {
                          return void (this.offset = e);
                        }
                        this._rollingBack && (this.offset, this.maxFiniteDuration);
                      }
                      !this._rollingBack || this.rollbackStartOffset <= this.duration
                        ? 0 !== this.iterations &&
                          (this.offset = Math.min(this.offset, this.maxFiniteDuration))
                        : ((this.offset =
                            this.rollbackStartOffset -
                            ((this.rollbackStartOffset - this.offset) % e)),
                          (this.rollbackStartOffset = 0));
                    }
                  },
                  {
                    key: 'reverse',
                    value: function () {
                      var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                      if (!this._running) {
                        return (
                          this._adjustOffset(t),
                          (this._rollingBack = !this._rollingBack),
                          t && this.play(!1),
                          void this.trigger('reverse', this.offset)
                        );
                      }
                      this.pause(!1, !1),
                        this._adjustOffset(),
                        (this._rollingBack = !this._rollingBack),
                        this.play(!1),
                        this.trigger('reverse', this.offset);
                    }
                  },
                  {
                    key: 'play',
                    value: function () {
                      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : pe,
                        e = h(a(u.prototype), 'play', this).call(this);
                      return t === pe && this.trigger('play', this.offset), e;
                    }
                  },
                  {
                    key: 'pause',
                    value: function () {
                      var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                        e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : pe,
                        n = h(a(u.prototype), 'pause', this).call(this);
                      return e === pe && this.trigger(t ? 'end' : 'pause', this.offset), n;
                    }
                  },
                  {
                    key: 'restart',
                    value: function () {
                      var t = h(a(u.prototype), 'restart', this).call(this, !1);
                      return this.trigger('restart', this.offset), t;
                    }
                  },
                  {
                    key: 'stop',
                    value: function () {
                      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : pe,
                        e = h(a(u.prototype), 'stop', this).call(this);
                      return t === pe && this.trigger('stop', this.offset), e;
                    }
                  },
                  {
                    key: '_apply',
                    value: function (t) {
                      var e = this,
                        n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : pe,
                        r = h(a(u.prototype), '_apply', this).call(this, t);
                      if (n === pe) {
                        var i = function () {
                          return e.trigger('keyframe', t);
                        };
                        window.requestAnimationFrame(i);
                      }
                      return r;
                    }
                  },
                  {
                    key: 'seekTo',
                    value: function (t) {
                      var e,
                        n,
                        r,
                        i = this._running;
                      i && this.pause(!1, !1),
                        (this.offset =
                          this.iterations > 0
                            ? ((e = t),
                              (n = 0),
                              (r = this.maxFiniteDuration),
                              e < n ? n : e > r ? r : e)
                            : Math.max(t, 0)),
                        this._apply(this.offset),
                        i && this.play(!1);
                    }
                  },
                  {
                    key: 'seek',
                    value: function (t) {
                      return this.seekTo(Math.round((t / 100) * this.maxFiniteDuration));
                    }
                  },
                  {
                    key: 'seekBy',
                    value: function (t) {
                      return this.seekTo(this.offset + t);
                    }
                  },
                  {
                    key: 'toggle',
                    value: function () {
                      return this._running
                        ? this.pause()
                        : this.reachedToEnd()
                        ? this.restart()
                        : this.play();
                    }
                  },
                  {
                    key: 'set',
                    value: function (t, e) {
                      if (me.includes(t)) {
                        var n = this._running;
                        n && this.pause(!1, !1),
                          (this._settings[t] = e),
                          n ? this.play(!1) : this._apply(this.offset, {}, !1);
                      }
                    }
                  },
                  {
                    key: 'destruct',
                    value: function () {
                      var t = this;
                      this.stop(),
                        this._handlers.forEach(function (t) {
                          t.element
                            ? t.element.removeEventListener(t.event, t.handler)
                            : t.callback && t.callback.call && t.callback.call();
                        });
                      var e = function () {},
                        n = Object.getOwnPropertyNames(Object.getPrototypeOf(this));
                      n.push.apply(n, v(Object.getOwnPropertyNames(this))),
                        n.forEach(function (n) {
                          'function' === typeof t[n] ? (t[n] = e) : delete t[n];
                        });
                    }
                  }
                ],
                [
                  {
                    key: 'build',
                    value: function (t) {
                      var e = h(a(u), 'build', this).call(this, t, ce);
                      if (!e) {
                        return null;
                      }
                      var n = e.el,
                        r = e.options,
                        i = e.player,
                        o = new ye(i),
                        l = new ge(o);
                      (o.on = l.on), (o.off = l.off), (i.trigger = l.trigger);
                      var s =
                        n.svgatorPlayer &&
                        n.svgatorPlayer.ready &&
                        n.svgatorPlayer.ready.call &&
                        n.svgatorPlayer.ready.call();
                      (n.svgatorPlayer = o),
                        (function (t) {
                          var e,
                            n,
                            r =
                              t &&
                              1 ===
                                (null === (e = t.ownerDocument) ||
                                void 0 === e ||
                                null === (n = e.childNodes) ||
                                void 0 === n
                                  ? void 0
                                  : n.length) &&
                              window.parent !== window,
                            i = null == t ? void 0 : t.firstElementChild;
                          if (!r || !i || 'a' !== i.tagName || i.getAttribute('target')) {
                            return;
                          }
                          i.setAttributeNS(null, 'target', '_parent');
                        })(n),
                        (function (t, e, n) {
                          if ('click' === n.start) {
                            var r = function () {
                              switch (n.click) {
                                case 'freeze':
                                  return !t._running && t.reachedToEnd() ? t.restart() : t.toggle();
                                case 'restart':
                                  return t.offset > 0 ? t.restart() : t.play();
                                case 'reverse':
                                  return t._running
                                    ? t.reverse()
                                    : t.reachedToEnd()
                                    ? 1 === t.fill
                                      ? t.reverse(!0)
                                      : t.restart()
                                    : t.play();
                                case 'none':
                                default:
                                  if (t._running) {
                                    return;
                                  }
                                  return t.reachedToEnd() ? t.restart() : t.play();
                              }
                            };
                            return (
                              t._handlers.push({ element: e, event: 'click', handler: r }),
                              void e.addEventListener('click', r)
                            );
                          }
                          if ('hover' === n.start) {
                            var i = function () {
                              return t.reachedToEnd()
                                ? t.restart()
                                : t._rollingBack
                                ? t.reverse()
                                : t.play();
                            };
                            t._handlers.push({ element: e, event: 'mouseenter', handler: i }),
                              e.addEventListener('mouseenter', i);
                            var o = function () {
                              switch (n.hover) {
                                case 'freeze':
                                  return t.pause();
                                case 'reset':
                                  return t.stop();
                                case 'reverse':
                                  if ((t.reverse(), t._running)) {
                                    return;
                                  }
                                  return t.play();
                                case 'none':
                                default:
                                  return;
                              }
                            };
                            return (
                              t._handlers.push({ element: e, event: 'mouseleave', handler: o }),
                              void e.addEventListener('mouseleave', o)
                            );
                          }
                          if ('scroll' === n.start) {
                            var u = new gt(e, n.scroll || 25, function (e) {
                              e ? (t.reachedToEnd() ? t.restart() : t.play()) : t.pause();
                            });
                            return void t._handlers.push({
                              callback: function () {
                                return u.destruct();
                              }
                            });
                          }
                          if ('programmatic' === n.start) {
                            return;
                          }
                          t.play();
                        })(i, n, r),
                        (function (t, e, n) {
                          var r;
                          'function' === typeof Event
                            ? (r = new Event('ready'))
                            : (r = document.createEvent('Event')).initEvent('ready', !0, !0);
                          if ((t.dispatchEvent(r), !n || !n.length)) {
                            return;
                          }
                          n.forEach(function (t) {
                            return e.ready(t);
                          });
                        })(n, n.svgatorPlayer, s);
                    }
                  }
                ]
              ),
              u
            );
          })(yt);
        return be.init(), be;
      });
      (function (s, i, o, w, d, a, b) {
        (a =
          Array.from(d.querySelectorAll('svg#' + i.root)).filter(n => !n.svgatorPlayer)[0] ||
          {}).svgatorPlayer = {
          ready: (function (a) {
            b = [];
            return function (c) {
              return c ? (b.push(c), a.svgatorPlayer) : b;
            };
          })(a)
        };
        w[o] = w[o] || {};
        w[o][s] = w[o][s] || [];
        w[o][s].push(i);
      })(
        '91c80d77',
        {
          root: 'emDeTYZbN5z1',
          version: '2022-05-04',
          animations: [
            {
              elements: {
                emDeTYZbN5z2: {
                  transform: {
                    data: { t: { x: -16.014304, y: -9.61595 } },
                    keys: {
                      o: [
                        {
                          t: 0,
                          v: { x: 16.014304, y: 9.61595, type: 'corner' },
                          e: [0.785, 0.135, 0.15, 0.86]
                        },
                        {
                          t: 200,
                          v: { x: 16.014304, y: 10.61595, type: 'corner' },
                          e: [0.785, 0.135, 0.15, 0.86]
                        },
                        { t: 400, v: { x: 16.014304, y: 9.61595, type: 'corner' } }
                      ]
                    }
                  }
                },
                emDeTYZbN5z3: {
                  transform: {
                    data: { t: { x: -15.897731, y: -17.40185 } },
                    keys: {
                      o: [
                        {
                          t: 0,
                          v: { x: 15.897731, y: 17.40185, type: 'corner' },
                          e: [0.785, 0.135, 0.15, 0.86]
                        },
                        {
                          t: 200,
                          v: { x: 15.897731, y: 18.40185, type: 'corner' },
                          e: [0.785, 0.135, 0.15, 0.86]
                        },
                        { t: 400, v: { x: 15.897731, y: 17.40185, type: 'corner' } }
                      ]
                    }
                  }
                },
                emDeTYZbN5z4: {
                  d: [
                    {
                      t: 0,
                      v: [
                        'M',
                        5.57907,
                        14.7706,
                        'C',
                        4.19125,
                        14.8347,
                        3.07031,
                        15.989,
                        3.07031,
                        17.4021,
                        'C',
                        3.07031,
                        18.8567,
                        4.25797,
                        20.0363,
                        5.71251,
                        20.0363,
                        'L',
                        5.76589,
                        20.0363,
                        'C',
                        6.13954,
                        22.0647,
                        7.12703,
                        23.9476,
                        8.60826,
                        25.4275,
                        'C',
                        10.5432,
                        27.3611,
                        13.1587,
                        28.4474,
                        15.8943,
                        28.4474,
                        'C',
                        18.6299,
                        28.4474,
                        21.2455,
                        27.3611,
                        23.1804,
                        25.4275,
                        'C',
                        24.6616,
                        23.9476,
                        25.6491,
                        22.0647,
                        26.0228,
                        20.0363,
                        'L',
                        26.0761,
                        20.0363,
                        'C',
                        27.5307,
                        20.0363,
                        28.7183,
                        18.8567,
                        28.7183,
                        17.4021,
                        'C',
                        28.7183,
                        15.989,
                        27.5974,
                        14.8347,
                        26.2096,
                        14.7706,
                        'L',
                        26.2096,
                        13.5002,
                        'C',
                        26.2096,
                        11.1343,
                        25.2621,
                        8.86437,
                        23.5941,
                        7.19098,
                        'C',
                        21.9127,
                        5.51758,
                        19.6441,
                        4.57812,
                        17.2822,
                        4.57812,
                        'C',
                        16.3614,
                        4.57812,
                        15.4273,
                        4.57812,
                        14.5065,
                        4.57812,
                        'C',
                        12.1445,
                        4.57812,
                        9.87598,
                        5.51758,
                        8.19458,
                        7.19098,
                        'C',
                        6.52653,
                        8.86437,
                        5.57907,
                        11.1343,
                        5.57907,
                        13.5002,
                        'L',
                        5.57907,
                        14.7706,
                        'Z',
                        'M',
                        24.9819,
                        14.4917,
                        'C',
                        20.4982,
                        14.409,
                        16.5882,
                        13.4442,
                        13.3722,
                        10.9394,
                        'C',
                        11.4239,
                        12.5047,
                        9.11535,
                        13.611,
                        6.80676,
                        14.1421,
                        'L',
                        6.80676,
                        18.1388,
                        'C',
                        6.80676,
                        20.5474,
                        7.76756,
                        22.8587,
                        9.47565,
                        24.5628,
                        'C',
                        11.1704,
                        26.2669,
                        13.479,
                        27.2237,
                        15.8943,
                        27.2237,
                        'C',
                        18.3097,
                        27.2237,
                        20.6183,
                        26.2669,
                        22.313,
                        24.5628,
                        'C',
                        24.0211,
                        22.8587,
                        24.9819,
                        20.5474,
                        24.9819,
                        18.1388,
                        'L',
                        24.9819,
                        14.4917,
                        'Z',
                        'M',
                        14.133841,
                        22.260072,
                        'C',
                        14.653841,
                        22.520072,
                        15.213841,
                        22.560072,
                        15.8943,
                        22.5504,
                        'C',
                        16.574759,
                        22.540728,
                        17.273841,
                        22.540072,
                        17.813841,
                        22.280072,
                        'C',
                        18.293841,
                        22.140072,
                        18.500341,
                        22.234472,
                        18.673841,
                        22.520072,
                        'C',
                        18.847241,
                        22.806972,
                        18.654141,
                        23.181272,
                        18.373841,
                        23.360072,
                        'C',
                        17.533841,
                        23.740072,
                        16.653841,
                        23.780072,
                        15.8943,
                        23.7741,
                        'C',
                        15.173841,
                        23.760072,
                        14.353841,
                        23.680072,
                        13.633841,
                        23.360072,
                        'C',
                        13.353641,
                        23.181272,
                        13.120341,
                        22.806972,
                        13.293841,
                        22.520072,
                        'C',
                        13.467341,
                        22.234472,
                        13.853641,
                        22.079972,
                        14.133841,
                        22.260072,
                        'Z',
                        'M',
                        15.3472,
                        17.7838,
                        'L',
                        14.5332,
                        19.9189,
                        'C',
                        14.4665,
                        20.1071,
                        14.4932,
                        20.3179,
                        14.6133,
                        20.4834,
                        'C',
                        14.72,
                        20.6475,
                        14.9068,
                        20.7463,
                        15.107,
                        20.7463,
                        'L',
                        16.1746,
                        20.7463,
                        'C',
                        16.5215,
                        20.7463,
                        16.7884,
                        20.4727,
                        16.7884,
                        20.1351,
                        'C',
                        16.7884,
                        19.7975,
                        16.5215,
                        19.5239,
                        16.1746,
                        19.5239,
                        'C',
                        16.1746,
                        19.5239,
                        15.964631,
                        19.575003,
                        15.9877,
                        19.5239,
                        'C',
                        16.193209,
                        19.06866,
                        16.4815,
                        18.2148,
                        16.4815,
                        18.2148,
                        'C',
                        16.6016,
                        17.8999,
                        16.4415,
                        17.5463,
                        16.1345,
                        17.4275,
                        'C',
                        15.8143,
                        17.3087,
                        15.4673,
                        17.4689,
                        15.3472,
                        17.7838,
                        'Z',
                        'M',
                        26.2096,
                        15.997,
                        'C',
                        26.9302,
                        16.0584,
                        27.4907,
                        16.6642,
                        27.4907,
                        17.4021,
                        'C',
                        27.4907,
                        18.1401,
                        26.9302,
                        18.7459,
                        26.2096,
                        18.8073,
                        'L',
                        26.2096,
                        15.997,
                        'Z',
                        'M',
                        5.57907,
                        15.997,
                        'L',
                        5.57907,
                        18.8073,
                        'C',
                        4.85847,
                        18.7459,
                        4.298,
                        18.1401,
                        4.298,
                        17.4021,
                        'C',
                        4.298,
                        16.6642,
                        4.85847,
                        16.0584,
                        5.57907,
                        15.997,
                        'Z',
                        'M',
                        11.9844,
                        15.65,
                        'C',
                        12.745,
                        15.65,
                        13.3722,
                        16.2705,
                        13.3722,
                        17.0365,
                        'C',
                        13.3722,
                        17.8011,
                        12.745,
                        18.423,
                        11.9844,
                        18.423,
                        'C',
                        11.2238,
                        18.423,
                        10.5966,
                        17.8011,
                        10.5966,
                        17.0365,
                        'C',
                        10.5966,
                        16.2705,
                        11.2238,
                        15.65,
                        11.9844,
                        15.65,
                        'Z',
                        'M',
                        20.0044,
                        15.65,
                        'C',
                        20.7784,
                        15.65,
                        21.3922,
                        16.2705,
                        21.3922,
                        17.0365,
                        'C',
                        21.3922,
                        17.8011,
                        20.7784,
                        18.423,
                        20.0044,
                        18.423,
                        'C',
                        19.2438,
                        18.423,
                        18.6166,
                        17.8011,
                        18.6166,
                        17.0365,
                        'C',
                        18.6166,
                        16.2705,
                        19.2438,
                        15.65,
                        20.0044,
                        15.65,
                        'Z',
                        'M',
                        24.9819,
                        13.268,
                        'C',
                        24.9152,
                        11.3104,
                        24.1145,
                        9.44485,
                        22.7267,
                        8.0557,
                        'C',
                        21.2855,
                        6.61183,
                        19.3239,
                        5.80048,
                        17.2822,
                        5.80048,
                        'C',
                        16.3614,
                        5.80048,
                        15.4273,
                        5.80048,
                        14.5065,
                        5.80048,
                        'C',
                        12.4648,
                        5.80048,
                        10.5032,
                        6.61183,
                        9.06197,
                        8.0557,
                        'C',
                        7.76756,
                        9.35278,
                        6.98024,
                        11.0635,
                        6.83345,
                        12.877,
                        'C',
                        9.00859,
                        12.3259,
                        11.1837,
                        11.2223,
                        12.9719,
                        9.68505,
                        'C',
                        13.1987,
                        9.49022,
                        13.5324,
                        9.48889,
                        13.7592,
                        9.67972,
                        'C',
                        16.8284,
                        12.2419,
                        20.6183,
                        13.184,
                        24.9819,
                        13.268,
                        'Z'
                      ]
                    },
                    {
                      t: 200,
                      v: [
                        'M',
                        5.57907,
                        15.7706,
                        'C',
                        4.19125,
                        15.8347,
                        3.07031,
                        16.989,
                        3.07031,
                        18.4021,
                        'C',
                        3.07031,
                        19.8567,
                        4.25797,
                        21.0363,
                        5.71251,
                        21.0363,
                        'L',
                        5.76589,
                        21.0363,
                        'C',
                        6.13954,
                        23.0647,
                        7.12703,
                        24.9476,
                        8.60826,
                        26.4275,
                        'C',
                        10.5432,
                        28.3611,
                        13.1587,
                        29.4474,
                        15.8943,
                        29.4474,
                        'C',
                        18.6299,
                        29.4474,
                        21.2455,
                        28.3611,
                        23.1804,
                        26.4275,
                        'C',
                        24.6616,
                        24.9476,
                        25.6491,
                        23.0647,
                        26.0228,
                        21.0363,
                        'L',
                        26.0761,
                        21.0363,
                        'C',
                        27.5307,
                        21.0363,
                        28.7183,
                        19.8567,
                        28.7183,
                        18.4021,
                        'C',
                        28.7183,
                        16.989,
                        27.5974,
                        15.8347,
                        26.2096,
                        15.7706,
                        'L',
                        26.2096,
                        14.5002,
                        'C',
                        26.2096,
                        12.1343,
                        25.2621,
                        9.86437,
                        23.5941,
                        8.19098,
                        'C',
                        21.9127,
                        6.51758,
                        19.6441,
                        5.57812,
                        17.2822,
                        5.57812,
                        'C',
                        16.3614,
                        5.57812,
                        15.4273,
                        5.57812,
                        14.5065,
                        5.57812,
                        'C',
                        12.1445,
                        5.57812,
                        9.87598,
                        6.51758,
                        8.19458,
                        8.19098,
                        'C',
                        6.52653,
                        9.86437,
                        5.57907,
                        12.1343,
                        5.57907,
                        14.5002,
                        'L',
                        5.57907,
                        15.7706,
                        'Z',
                        'M',
                        24.9819,
                        15.4917,
                        'C',
                        20.4982,
                        15.409,
                        16.5882,
                        14.4442,
                        13.3722,
                        11.9394,
                        'C',
                        11.4239,
                        13.5047,
                        9.11535,
                        14.611,
                        6.80676,
                        15.1421,
                        'L',
                        6.80676,
                        19.1388,
                        'C',
                        6.80676,
                        21.5474,
                        7.76756,
                        23.8587,
                        9.47565,
                        25.5628,
                        'C',
                        11.1704,
                        27.2669,
                        13.479,
                        28.2237,
                        15.8943,
                        28.2237,
                        'C',
                        18.3097,
                        28.2237,
                        20.6183,
                        27.2669,
                        22.313,
                        25.5628,
                        'C',
                        24.0211,
                        23.8587,
                        24.9819,
                        21.5474,
                        24.9819,
                        19.1388,
                        'L',
                        24.9819,
                        15.4917,
                        'Z',
                        'M',
                        14.133841,
                        24.260072,
                        'C',
                        14.653841,
                        24.520072,
                        15.213841,
                        24.560072,
                        15.8943,
                        24.5504,
                        'C',
                        16.574759,
                        24.540728,
                        17.273841,
                        24.540072,
                        17.813841,
                        24.280072,
                        'C',
                        18.293841,
                        24.140072,
                        18.500341,
                        24.234472,
                        18.673841,
                        24.520072,
                        'C',
                        18.847241,
                        24.806972,
                        18.654141,
                        25.181272,
                        18.373841,
                        25.360072,
                        'C',
                        17.533841,
                        25.740072,
                        16.653841,
                        25.780072,
                        15.8943,
                        25.7741,
                        'C',
                        15.173841,
                        25.760072,
                        14.353841,
                        25.680072,
                        13.633841,
                        25.360072,
                        'C',
                        13.353641,
                        25.181272,
                        13.120341,
                        24.806972,
                        13.293841,
                        24.520072,
                        'C',
                        13.467341,
                        24.234472,
                        13.853641,
                        24.079972,
                        14.133841,
                        24.260072,
                        'Z',
                        'M',
                        15.3472,
                        19.7838,
                        'L',
                        14.5332,
                        21.9189,
                        'C',
                        14.4665,
                        22.1071,
                        14.4932,
                        22.3179,
                        14.6133,
                        22.4834,
                        'C',
                        14.72,
                        22.6475,
                        14.9068,
                        22.7463,
                        15.107,
                        22.7463,
                        'L',
                        16.1746,
                        22.7463,
                        'C',
                        16.5215,
                        22.7463,
                        16.7884,
                        22.4727,
                        16.7884,
                        22.1351,
                        'C',
                        16.7884,
                        21.7975,
                        16.5215,
                        21.5239,
                        16.1746,
                        21.5239,
                        'C',
                        16.1746,
                        21.5239,
                        15.964631,
                        21.575003,
                        15.9877,
                        21.5239,
                        'C',
                        16.193209,
                        21.06866,
                        16.4815,
                        20.2148,
                        16.4815,
                        20.2148,
                        'C',
                        16.6016,
                        19.8999,
                        16.4415,
                        19.5463,
                        16.1345,
                        19.4275,
                        'C',
                        15.8143,
                        19.3087,
                        15.4673,
                        19.4689,
                        15.3472,
                        19.7838,
                        'Z',
                        'M',
                        26.2096,
                        16.997,
                        'C',
                        26.9302,
                        17.0584,
                        27.4907,
                        17.6642,
                        27.4907,
                        18.4021,
                        'C',
                        27.4907,
                        19.1401,
                        26.9302,
                        19.7459,
                        26.2096,
                        19.8073,
                        'L',
                        26.2096,
                        16.997,
                        'Z',
                        'M',
                        5.57907,
                        16.997,
                        'L',
                        5.57907,
                        19.8073,
                        'C',
                        4.85847,
                        19.7459,
                        4.298,
                        19.1401,
                        4.298,
                        18.4021,
                        'C',
                        4.298,
                        17.6642,
                        4.85847,
                        17.0584,
                        5.57907,
                        16.997,
                        'Z',
                        'M',
                        11.9844,
                        17.65,
                        'C',
                        12.745,
                        17.65,
                        13.3722,
                        18.2705,
                        13.3722,
                        19.0365,
                        'C',
                        13.3722,
                        19.8011,
                        12.745,
                        20.423,
                        11.9844,
                        20.423,
                        'C',
                        11.2238,
                        20.423,
                        10.5966,
                        19.8011,
                        10.5966,
                        19.0365,
                        'C',
                        10.5966,
                        18.2705,
                        11.2238,
                        17.65,
                        11.9844,
                        17.65,
                        'Z',
                        'M',
                        20.0044,
                        17.65,
                        'C',
                        20.7784,
                        17.65,
                        21.3922,
                        18.2705,
                        21.3922,
                        19.0365,
                        'C',
                        21.3922,
                        19.8011,
                        20.7784,
                        20.423,
                        20.0044,
                        20.423,
                        'C',
                        19.2438,
                        20.423,
                        18.6166,
                        19.8011,
                        18.6166,
                        19.0365,
                        'C',
                        18.6166,
                        18.2705,
                        19.2438,
                        17.65,
                        20.0044,
                        17.65,
                        'Z',
                        'M',
                        24.9819,
                        14.268,
                        'C',
                        24.9152,
                        12.3104,
                        24.1145,
                        10.44485,
                        22.7267,
                        9.0557,
                        'C',
                        21.2855,
                        7.61183,
                        19.3239,
                        6.80048,
                        17.2822,
                        6.80048,
                        'C',
                        16.3614,
                        6.80048,
                        15.4273,
                        6.80048,
                        14.5065,
                        6.80048,
                        'C',
                        12.4648,
                        6.80048,
                        10.5032,
                        7.61183,
                        9.06197,
                        9.0557,
                        'C',
                        7.76756,
                        10.35278,
                        6.98024,
                        12.0635,
                        6.83345,
                        13.877,
                        'C',
                        9.00859,
                        13.3259,
                        11.1837,
                        12.2223,
                        12.9719,
                        10.68505,
                        'C',
                        13.1987,
                        10.49022,
                        13.5324,
                        10.48889,
                        13.7592,
                        10.67972,
                        'C',
                        16.8284,
                        13.2419,
                        20.6183,
                        14.184,
                        24.9819,
                        14.268,
                        'Z'
                      ]
                    },
                    {
                      t: 400,
                      v: [
                        'M',
                        5.57907,
                        14.7706,
                        'C',
                        4.19125,
                        14.8347,
                        3.07031,
                        15.989,
                        3.07031,
                        17.4021,
                        'C',
                        3.07031,
                        18.8567,
                        4.25797,
                        20.0363,
                        5.71251,
                        20.0363,
                        'L',
                        5.76589,
                        20.0363,
                        'C',
                        6.13954,
                        22.0647,
                        7.12703,
                        23.9476,
                        8.60826,
                        25.4275,
                        'C',
                        10.5432,
                        27.3611,
                        13.1587,
                        28.4474,
                        15.8943,
                        28.4474,
                        'C',
                        18.6299,
                        28.4474,
                        21.2455,
                        27.3611,
                        23.1804,
                        25.4275,
                        'C',
                        24.6616,
                        23.9476,
                        25.6491,
                        22.0647,
                        26.0228,
                        20.0363,
                        'L',
                        26.0761,
                        20.0363,
                        'C',
                        27.5307,
                        20.0363,
                        28.7183,
                        18.8567,
                        28.7183,
                        17.4021,
                        'C',
                        28.7183,
                        15.989,
                        27.5974,
                        14.8347,
                        26.2096,
                        14.7706,
                        'L',
                        26.2096,
                        13.5002,
                        'C',
                        26.2096,
                        11.1343,
                        25.2621,
                        8.86437,
                        23.5941,
                        7.19098,
                        'C',
                        21.9127,
                        5.51758,
                        19.6441,
                        4.57812,
                        17.2822,
                        4.57812,
                        'C',
                        16.3614,
                        4.57812,
                        15.4273,
                        4.57812,
                        14.5065,
                        4.57812,
                        'C',
                        12.1445,
                        4.57812,
                        9.87598,
                        5.51758,
                        8.19458,
                        7.19098,
                        'C',
                        6.52653,
                        8.86437,
                        5.57907,
                        11.1343,
                        5.57907,
                        13.5002,
                        'L',
                        5.57907,
                        14.7706,
                        'Z',
                        'M',
                        24.9819,
                        14.4917,
                        'C',
                        20.4982,
                        14.409,
                        16.5882,
                        13.4442,
                        13.3722,
                        10.9394,
                        'C',
                        11.4239,
                        12.5047,
                        9.11535,
                        13.611,
                        6.80676,
                        14.1421,
                        'L',
                        6.80676,
                        18.1388,
                        'C',
                        6.80676,
                        20.5474,
                        7.76756,
                        22.8587,
                        9.47565,
                        24.5628,
                        'C',
                        11.1704,
                        26.2669,
                        13.479,
                        27.2237,
                        15.8943,
                        27.2237,
                        'C',
                        18.3097,
                        27.2237,
                        20.6183,
                        26.2669,
                        22.313,
                        24.5628,
                        'C',
                        24.0211,
                        22.8587,
                        24.9819,
                        20.5474,
                        24.9819,
                        18.1388,
                        'L',
                        24.9819,
                        14.4917,
                        'Z',
                        'M',
                        14.133841,
                        22.260072,
                        'C',
                        14.653841,
                        22.520072,
                        15.213841,
                        22.560072,
                        15.8943,
                        22.5504,
                        'C',
                        16.574759,
                        22.540728,
                        17.273841,
                        22.540072,
                        17.813841,
                        22.280072,
                        'C',
                        18.293841,
                        22.140072,
                        18.500341,
                        22.234472,
                        18.673841,
                        22.520072,
                        'C',
                        18.847241,
                        22.806972,
                        18.654141,
                        23.181272,
                        18.373841,
                        23.360072,
                        'C',
                        17.533841,
                        23.740072,
                        16.653841,
                        23.780072,
                        15.8943,
                        23.7741,
                        'C',
                        15.173841,
                        23.760072,
                        14.353841,
                        23.680072,
                        13.633841,
                        23.360072,
                        'C',
                        13.353641,
                        23.181272,
                        13.120341,
                        22.806972,
                        13.293841,
                        22.520072,
                        'C',
                        13.467341,
                        22.234472,
                        13.853641,
                        22.079972,
                        14.133841,
                        22.260072,
                        'Z',
                        'M',
                        15.3472,
                        17.7838,
                        'L',
                        14.5332,
                        19.9189,
                        'C',
                        14.4665,
                        20.1071,
                        14.4932,
                        20.3179,
                        14.6133,
                        20.4834,
                        'C',
                        14.72,
                        20.6475,
                        14.9068,
                        20.7463,
                        15.107,
                        20.7463,
                        'L',
                        16.1746,
                        20.7463,
                        'C',
                        16.5215,
                        20.7463,
                        16.7884,
                        20.4727,
                        16.7884,
                        20.1351,
                        'C',
                        16.7884,
                        19.7975,
                        16.5215,
                        19.5239,
                        16.1746,
                        19.5239,
                        'C',
                        16.1746,
                        19.5239,
                        15.964631,
                        19.575003,
                        15.9877,
                        19.5239,
                        'C',
                        16.193209,
                        19.06866,
                        16.4815,
                        18.2148,
                        16.4815,
                        18.2148,
                        'C',
                        16.6016,
                        17.8999,
                        16.4415,
                        17.5463,
                        16.1345,
                        17.4275,
                        'C',
                        15.8143,
                        17.3087,
                        15.4673,
                        17.4689,
                        15.3472,
                        17.7838,
                        'Z',
                        'M',
                        26.2096,
                        15.997,
                        'C',
                        26.9302,
                        16.0584,
                        27.4907,
                        16.6642,
                        27.4907,
                        17.4021,
                        'C',
                        27.4907,
                        18.1401,
                        26.9302,
                        18.7459,
                        26.2096,
                        18.8073,
                        'L',
                        26.2096,
                        15.997,
                        'Z',
                        'M',
                        5.57907,
                        15.997,
                        'L',
                        5.57907,
                        18.8073,
                        'C',
                        4.85847,
                        18.7459,
                        4.298,
                        18.1401,
                        4.298,
                        17.4021,
                        'C',
                        4.298,
                        16.6642,
                        4.85847,
                        16.0584,
                        5.57907,
                        15.997,
                        'Z',
                        'M',
                        11.9844,
                        15.65,
                        'C',
                        12.745,
                        15.65,
                        13.3722,
                        16.2705,
                        13.3722,
                        17.0365,
                        'C',
                        13.3722,
                        17.8011,
                        12.745,
                        18.423,
                        11.9844,
                        18.423,
                        'C',
                        11.2238,
                        18.423,
                        10.5966,
                        17.8011,
                        10.5966,
                        17.0365,
                        'C',
                        10.5966,
                        16.2705,
                        11.2238,
                        15.65,
                        11.9844,
                        15.65,
                        'Z',
                        'M',
                        20.0044,
                        15.65,
                        'C',
                        20.7784,
                        15.65,
                        21.3922,
                        16.2705,
                        21.3922,
                        17.0365,
                        'C',
                        21.3922,
                        17.8011,
                        20.7784,
                        18.423,
                        20.0044,
                        18.423,
                        'C',
                        19.2438,
                        18.423,
                        18.6166,
                        17.8011,
                        18.6166,
                        17.0365,
                        'C',
                        18.6166,
                        16.2705,
                        19.2438,
                        15.65,
                        20.0044,
                        15.65,
                        'Z',
                        'M',
                        24.9819,
                        13.268,
                        'C',
                        24.9152,
                        11.3104,
                        24.1145,
                        9.44485,
                        22.7267,
                        8.0557,
                        'C',
                        21.2855,
                        6.61183,
                        19.3239,
                        5.80048,
                        17.2822,
                        5.80048,
                        'C',
                        16.3614,
                        5.80048,
                        15.4273,
                        5.80048,
                        14.5065,
                        5.80048,
                        'C',
                        12.4648,
                        5.80048,
                        10.5032,
                        6.61183,
                        9.06197,
                        8.0557,
                        'C',
                        7.76756,
                        9.35278,
                        6.98024,
                        11.0635,
                        6.83345,
                        12.877,
                        'C',
                        9.00859,
                        12.3259,
                        11.1837,
                        11.2223,
                        12.9719,
                        9.68505,
                        'C',
                        13.1987,
                        9.49022,
                        13.5324,
                        9.48889,
                        13.7592,
                        9.67972,
                        'C',
                        16.8284,
                        12.2419,
                        20.6183,
                        13.184,
                        24.9819,
                        13.268,
                        'Z'
                      ]
                    },
                    {
                      t: 500,
                      v: [
                        'M',
                        5.57907,
                        14.7706,
                        'C',
                        4.19125,
                        14.8347,
                        3.07031,
                        15.989,
                        3.07031,
                        17.4021,
                        'C',
                        3.07031,
                        18.8567,
                        4.25797,
                        20.0363,
                        5.71251,
                        20.0363,
                        'L',
                        5.76589,
                        20.0363,
                        'C',
                        6.13954,
                        22.0647,
                        7.12703,
                        23.9476,
                        8.60826,
                        25.4275,
                        'C',
                        10.5432,
                        27.3611,
                        13.1587,
                        28.4474,
                        15.8943,
                        28.4474,
                        'C',
                        18.6299,
                        28.4474,
                        21.2455,
                        27.3611,
                        23.1804,
                        25.4275,
                        'C',
                        24.6616,
                        23.9476,
                        25.6491,
                        22.0647,
                        26.0228,
                        20.0363,
                        'L',
                        26.0761,
                        20.0363,
                        'C',
                        27.5307,
                        20.0363,
                        28.7183,
                        18.8567,
                        28.7183,
                        17.4021,
                        'C',
                        28.7183,
                        15.989,
                        27.5974,
                        14.8347,
                        26.2096,
                        14.7706,
                        'L',
                        26.2096,
                        13.5002,
                        'C',
                        26.2096,
                        11.1343,
                        25.2621,
                        8.86437,
                        23.5941,
                        7.19098,
                        'C',
                        21.9127,
                        5.51758,
                        19.6441,
                        4.57812,
                        17.2822,
                        4.57812,
                        'C',
                        16.3614,
                        4.57812,
                        15.4273,
                        4.57812,
                        14.5065,
                        4.57812,
                        'C',
                        12.1445,
                        4.57812,
                        9.87598,
                        5.51758,
                        8.19458,
                        7.19098,
                        'C',
                        6.52653,
                        8.86437,
                        5.57907,
                        11.1343,
                        5.57907,
                        13.5002,
                        'L',
                        5.57907,
                        14.7706,
                        'Z',
                        'M',
                        24.9819,
                        14.4917,
                        'C',
                        20.4982,
                        14.409,
                        16.5882,
                        13.4442,
                        13.3722,
                        10.9394,
                        'C',
                        11.4239,
                        12.5047,
                        9.11535,
                        13.611,
                        6.80676,
                        14.1421,
                        'L',
                        6.80676,
                        18.1388,
                        'C',
                        6.80676,
                        20.5474,
                        7.76756,
                        22.8587,
                        9.47565,
                        24.5628,
                        'C',
                        11.1704,
                        26.2669,
                        13.479,
                        27.2237,
                        15.8943,
                        27.2237,
                        'C',
                        18.3097,
                        27.2237,
                        20.6183,
                        26.2669,
                        22.313,
                        24.5628,
                        'C',
                        24.0211,
                        22.8587,
                        24.9819,
                        20.5474,
                        24.9819,
                        18.1388,
                        'L',
                        24.9819,
                        14.4917,
                        'Z',
                        'M',
                        14.133841,
                        22.260072,
                        'C',
                        14.653841,
                        22.520072,
                        15.213841,
                        22.560072,
                        15.8943,
                        22.5504,
                        'C',
                        16.574759,
                        22.540728,
                        17.273841,
                        22.540072,
                        17.813841,
                        22.280072,
                        'C',
                        18.293841,
                        22.140072,
                        18.500341,
                        22.234472,
                        18.673841,
                        22.520072,
                        'C',
                        18.847241,
                        22.806972,
                        18.654141,
                        23.181272,
                        18.373841,
                        23.360072,
                        'C',
                        17.533841,
                        23.740072,
                        16.653841,
                        23.780072,
                        15.8943,
                        23.7741,
                        'C',
                        15.173841,
                        23.760072,
                        14.353841,
                        23.680072,
                        13.633841,
                        23.360072,
                        'C',
                        13.353641,
                        23.181272,
                        13.120341,
                        22.806972,
                        13.293841,
                        22.520072,
                        'C',
                        13.467341,
                        22.234472,
                        13.853641,
                        22.079972,
                        14.133841,
                        22.260072,
                        'Z',
                        'M',
                        15.3472,
                        17.7838,
                        'L',
                        14.5332,
                        19.9189,
                        'C',
                        14.4665,
                        20.1071,
                        14.4932,
                        20.3179,
                        14.6133,
                        20.4834,
                        'C',
                        14.72,
                        20.6475,
                        14.9068,
                        20.7463,
                        15.107,
                        20.7463,
                        'L',
                        16.1746,
                        20.7463,
                        'C',
                        16.5215,
                        20.7463,
                        16.7884,
                        20.4727,
                        16.7884,
                        20.1351,
                        'C',
                        16.7884,
                        19.7975,
                        16.5215,
                        19.5239,
                        16.1746,
                        19.5239,
                        'C',
                        16.1746,
                        19.5239,
                        15.964631,
                        19.575003,
                        15.9877,
                        19.5239,
                        'C',
                        16.193209,
                        19.06866,
                        16.4815,
                        18.2148,
                        16.4815,
                        18.2148,
                        'C',
                        16.6016,
                        17.8999,
                        16.4415,
                        17.5463,
                        16.1345,
                        17.4275,
                        'C',
                        15.8143,
                        17.3087,
                        15.4673,
                        17.4689,
                        15.3472,
                        17.7838,
                        'Z',
                        'M',
                        26.2096,
                        15.997,
                        'C',
                        26.9302,
                        16.0584,
                        27.4907,
                        16.6642,
                        27.4907,
                        17.4021,
                        'C',
                        27.4907,
                        18.1401,
                        26.9302,
                        18.7459,
                        26.2096,
                        18.8073,
                        'L',
                        26.2096,
                        15.997,
                        'Z',
                        'M',
                        5.57907,
                        15.997,
                        'L',
                        5.57907,
                        18.8073,
                        'C',
                        4.85847,
                        18.7459,
                        4.298,
                        18.1401,
                        4.298,
                        17.4021,
                        'C',
                        4.298,
                        16.6642,
                        4.85847,
                        16.0584,
                        5.57907,
                        15.997,
                        'Z',
                        'M',
                        11.9844,
                        15.65,
                        'C',
                        12.745,
                        15.65,
                        13.3722,
                        16.2705,
                        13.3722,
                        17.0365,
                        'C',
                        13.3722,
                        17.8011,
                        12.745,
                        18.423,
                        11.9844,
                        18.423,
                        'C',
                        11.2238,
                        18.423,
                        10.5966,
                        17.8011,
                        10.5966,
                        17.0365,
                        'C',
                        10.5966,
                        16.2705,
                        11.2238,
                        15.65,
                        11.9844,
                        15.65,
                        'Z',
                        'M',
                        20.0044,
                        15.65,
                        'C',
                        20.7784,
                        15.65,
                        21.3922,
                        16.2705,
                        21.3922,
                        17.0365,
                        'C',
                        21.3922,
                        17.8011,
                        20.7784,
                        18.423,
                        20.0044,
                        18.423,
                        'C',
                        19.2438,
                        18.423,
                        18.6166,
                        17.8011,
                        18.6166,
                        17.0365,
                        'C',
                        18.6166,
                        16.2705,
                        19.2438,
                        15.65,
                        20.0044,
                        15.65,
                        'Z',
                        'M',
                        24.9819,
                        13.268,
                        'C',
                        24.9152,
                        11.3104,
                        24.1145,
                        9.44485,
                        22.7267,
                        8.0557,
                        'C',
                        21.2855,
                        6.61183,
                        19.3239,
                        5.80048,
                        17.2822,
                        5.80048,
                        'C',
                        16.3614,
                        5.80048,
                        15.4273,
                        5.80048,
                        14.5065,
                        5.80048,
                        'C',
                        12.4648,
                        5.80048,
                        10.5032,
                        6.61183,
                        9.06197,
                        8.0557,
                        'C',
                        7.76756,
                        9.35278,
                        6.98024,
                        11.0635,
                        6.83345,
                        12.877,
                        'C',
                        9.00859,
                        12.3259,
                        11.1837,
                        11.2223,
                        12.9719,
                        9.68505,
                        'C',
                        13.1987,
                        9.49022,
                        13.5324,
                        9.48889,
                        13.7592,
                        9.67972,
                        'C',
                        16.8284,
                        12.2419,
                        20.6183,
                        13.184,
                        24.9819,
                        13.268,
                        'Z'
                      ],
                      e: [0.785, 0.135, 0.15, 0.86]
                    },
                    {
                      t: 700,
                      v: [
                        'M',
                        5.57907,
                        14.7706,
                        'C',
                        4.19125,
                        14.8347,
                        3.07031,
                        15.989,
                        3.07031,
                        17.4021,
                        'C',
                        3.07031,
                        18.8567,
                        4.25797,
                        20.0363,
                        5.71251,
                        20.0363,
                        'L',
                        5.76589,
                        20.0363,
                        'C',
                        6.13954,
                        22.0647,
                        7.12703,
                        23.9476,
                        8.60826,
                        25.4275,
                        'C',
                        10.5432,
                        27.3611,
                        13.1587,
                        28.4474,
                        15.8943,
                        28.4474,
                        'C',
                        18.6299,
                        28.4474,
                        21.2455,
                        27.3611,
                        23.1804,
                        25.4275,
                        'C',
                        24.6616,
                        23.9476,
                        25.6491,
                        22.0647,
                        26.0228,
                        20.0363,
                        'L',
                        26.0761,
                        20.0363,
                        'C',
                        27.5307,
                        20.0363,
                        28.7183,
                        18.8567,
                        28.7183,
                        17.4021,
                        'C',
                        28.7183,
                        15.989,
                        27.5974,
                        14.8347,
                        26.2096,
                        14.7706,
                        'L',
                        26.2096,
                        13.5002,
                        'C',
                        26.2096,
                        11.1343,
                        25.2621,
                        8.86437,
                        23.5941,
                        7.19098,
                        'C',
                        21.9127,
                        5.51758,
                        19.6441,
                        4.57812,
                        17.2822,
                        4.57812,
                        'C',
                        16.3614,
                        4.57812,
                        15.4273,
                        4.57812,
                        14.5065,
                        4.57812,
                        'C',
                        12.1445,
                        4.57812,
                        9.87598,
                        5.51758,
                        8.19458,
                        7.19098,
                        'C',
                        6.52653,
                        8.86437,
                        5.57907,
                        11.1343,
                        5.57907,
                        13.5002,
                        'L',
                        5.57907,
                        14.7706,
                        'Z',
                        'M',
                        24.9819,
                        14.4917,
                        'C',
                        20.4982,
                        14.409,
                        16.5882,
                        13.4442,
                        13.3722,
                        10.9394,
                        'C',
                        11.4239,
                        12.5047,
                        9.11535,
                        13.611,
                        6.80676,
                        14.1421,
                        'L',
                        6.80676,
                        18.1388,
                        'C',
                        6.80676,
                        20.5474,
                        7.76756,
                        22.8587,
                        9.47565,
                        24.5628,
                        'C',
                        11.1704,
                        26.2669,
                        13.479,
                        27.2237,
                        15.8943,
                        27.2237,
                        'C',
                        18.3097,
                        27.2237,
                        20.6183,
                        26.2669,
                        22.313,
                        24.5628,
                        'C',
                        24.0211,
                        22.8587,
                        24.9819,
                        20.5474,
                        24.9819,
                        18.1388,
                        'L',
                        24.9819,
                        14.4917,
                        'Z',
                        'M',
                        13.634842,
                        21.987198,
                        'C',
                        14.291769,
                        22.374366,
                        15.053034,
                        22.554246,
                        15.8943,
                        22.5504,
                        'C',
                        16.735627,
                        22.546554,
                        17.552189,
                        22.382318,
                        18.217068,
                        21.99515,
                        'C',
                        18.576707,
                        21.830993,
                        18.891942,
                        21.920755,
                        19.065442,
                        22.206355,
                        'C',
                        19.238842,
                        22.493255,
                        19.113874,
                        22.869603,
                        18.833574,
                        23.048403,
                        'C',
                        17.928876,
                        23.554788,
                        16.911767,
                        23.776474,
                        15.8943,
                        23.7741,
                        'C',
                        14.892431,
                        23.768523,
                        13.899179,
                        23.530933,
                        13.042131,
                        23.048403,
                        'C',
                        12.761931,
                        22.869603,
                        12.62092,
                        22.493255,
                        12.79442,
                        22.206355,
                        'C',
                        12.96792,
                        21.920755,
                        13.354642,
                        21.807098,
                        13.634842,
                        21.987198,
                        'Z',
                        'M',
                        15.3472,
                        17.7838,
                        'L',
                        14.5332,
                        19.9189,
                        'C',
                        14.4665,
                        20.1071,
                        14.4932,
                        20.3179,
                        14.6133,
                        20.4834,
                        'C',
                        14.72,
                        20.6475,
                        14.9068,
                        20.7463,
                        15.107,
                        20.7463,
                        'L',
                        16.1746,
                        20.7463,
                        'C',
                        16.5215,
                        20.7463,
                        16.7884,
                        20.4727,
                        16.7884,
                        20.1351,
                        'C',
                        16.7884,
                        19.7975,
                        16.5215,
                        19.5239,
                        16.1746,
                        19.5239,
                        'C',
                        16.1746,
                        19.5239,
                        15.978528,
                        19.544218,
                        15.9877,
                        19.5239,
                        'C',
                        16.069409,
                        19.3429,
                        16.4815,
                        18.2148,
                        16.4815,
                        18.2148,
                        'C',
                        16.6016,
                        17.8999,
                        16.4415,
                        17.5463,
                        16.1345,
                        17.4275,
                        'C',
                        15.8143,
                        17.3087,
                        15.4673,
                        17.4689,
                        15.3472,
                        17.7838,
                        'Z',
                        'M',
                        26.2096,
                        15.997,
                        'C',
                        26.9302,
                        16.0584,
                        27.4907,
                        16.6642,
                        27.4907,
                        17.4021,
                        'C',
                        27.4907,
                        18.1401,
                        26.9302,
                        18.7459,
                        26.2096,
                        18.8073,
                        'L',
                        26.2096,
                        15.997,
                        'Z',
                        'M',
                        5.57907,
                        15.997,
                        'L',
                        5.57907,
                        18.8073,
                        'C',
                        4.85847,
                        18.7459,
                        4.298,
                        18.1401,
                        4.298,
                        17.4021,
                        'C',
                        4.298,
                        16.6642,
                        4.85847,
                        16.0584,
                        5.57907,
                        15.997,
                        'Z',
                        'M',
                        11.9844,
                        15.65,
                        'C',
                        12.745,
                        15.65,
                        13.3722,
                        16.2705,
                        13.3722,
                        17.0365,
                        'C',
                        13.3722,
                        17.8011,
                        12.745,
                        18.423,
                        11.9844,
                        18.423,
                        'C',
                        11.2238,
                        18.423,
                        10.5966,
                        17.8011,
                        10.5966,
                        17.0365,
                        'C',
                        10.5966,
                        16.2705,
                        11.2238,
                        15.65,
                        11.9844,
                        15.65,
                        'Z',
                        'M',
                        20.0044,
                        15.65,
                        'C',
                        20.7784,
                        15.65,
                        21.3922,
                        16.2705,
                        21.3922,
                        17.0365,
                        'C',
                        21.3922,
                        17.8011,
                        20.7784,
                        18.423,
                        20.0044,
                        18.423,
                        'C',
                        19.2438,
                        18.423,
                        18.6166,
                        17.8011,
                        18.6166,
                        17.0365,
                        'C',
                        18.6166,
                        16.2705,
                        19.2438,
                        15.65,
                        20.0044,
                        15.65,
                        'Z',
                        'M',
                        24.9819,
                        13.268,
                        'C',
                        24.9152,
                        11.3104,
                        24.1145,
                        9.44485,
                        22.7267,
                        8.0557,
                        'C',
                        21.2855,
                        6.61183,
                        19.3239,
                        5.80048,
                        17.2822,
                        5.80048,
                        'C',
                        16.3614,
                        5.80048,
                        15.4273,
                        5.80048,
                        14.5065,
                        5.80048,
                        'C',
                        12.4648,
                        5.80048,
                        10.5032,
                        6.61183,
                        9.06197,
                        8.0557,
                        'C',
                        7.76756,
                        9.35278,
                        6.98024,
                        11.0635,
                        6.83345,
                        12.877,
                        'C',
                        9.00859,
                        12.3259,
                        11.1837,
                        11.2223,
                        12.9719,
                        9.68505,
                        'C',
                        13.1987,
                        9.49022,
                        13.5324,
                        9.48889,
                        13.7592,
                        9.67972,
                        'C',
                        16.8284,
                        12.2419,
                        20.6183,
                        13.184,
                        24.9819,
                        13.268,
                        'Z'
                      ],
                      e: [0.785, 0.135, 0.15, 0.86]
                    },
                    {
                      t: 900,
                      v: [
                        'M',
                        5.57907,
                        14.7706,
                        'C',
                        4.19125,
                        14.8347,
                        3.07031,
                        15.989,
                        3.07031,
                        17.4021,
                        'C',
                        3.07031,
                        18.8567,
                        4.25797,
                        20.0363,
                        5.71251,
                        20.0363,
                        'L',
                        5.76589,
                        20.0363,
                        'C',
                        6.13954,
                        22.0647,
                        7.12703,
                        23.9476,
                        8.60826,
                        25.4275,
                        'C',
                        10.5432,
                        27.3611,
                        13.1587,
                        28.4474,
                        15.8943,
                        28.4474,
                        'C',
                        18.6299,
                        28.4474,
                        21.2455,
                        27.3611,
                        23.1804,
                        25.4275,
                        'C',
                        24.6616,
                        23.9476,
                        25.6491,
                        22.0647,
                        26.0228,
                        20.0363,
                        'L',
                        26.0761,
                        20.0363,
                        'C',
                        27.5307,
                        20.0363,
                        28.7183,
                        18.8567,
                        28.7183,
                        17.4021,
                        'C',
                        28.7183,
                        15.989,
                        27.5974,
                        14.8347,
                        26.2096,
                        14.7706,
                        'L',
                        26.2096,
                        13.5002,
                        'C',
                        26.2096,
                        11.1343,
                        25.2621,
                        8.86437,
                        23.5941,
                        7.19098,
                        'C',
                        21.9127,
                        5.51758,
                        19.6441,
                        4.57812,
                        17.2822,
                        4.57812,
                        'C',
                        16.3614,
                        4.57812,
                        15.4273,
                        4.57812,
                        14.5065,
                        4.57812,
                        'C',
                        12.1445,
                        4.57812,
                        9.87598,
                        5.51758,
                        8.19458,
                        7.19098,
                        'C',
                        6.52653,
                        8.86437,
                        5.57907,
                        11.1343,
                        5.57907,
                        13.5002,
                        'L',
                        5.57907,
                        14.7706,
                        'Z',
                        'M',
                        24.9819,
                        14.4917,
                        'C',
                        20.4982,
                        14.409,
                        16.5882,
                        13.4442,
                        13.3722,
                        10.9394,
                        'C',
                        11.4239,
                        12.5047,
                        9.11535,
                        13.611,
                        6.80676,
                        14.1421,
                        'L',
                        6.80676,
                        18.1388,
                        'C',
                        6.80676,
                        20.5474,
                        7.76756,
                        22.8587,
                        9.47565,
                        24.5628,
                        'C',
                        11.1704,
                        26.2669,
                        13.479,
                        27.2237,
                        15.8943,
                        27.2237,
                        'C',
                        18.3097,
                        27.2237,
                        20.6183,
                        26.2669,
                        22.313,
                        24.5628,
                        'C',
                        24.0211,
                        22.8587,
                        24.9819,
                        20.5474,
                        24.9819,
                        18.1388,
                        'L',
                        24.9819,
                        14.4917,
                        'Z',
                        'M',
                        13.3055,
                        21.8071,
                        'C',
                        14.0528,
                        22.2782,
                        14.9469,
                        22.5504,
                        15.8943,
                        22.5504,
                        'C',
                        16.8418,
                        22.5504,
                        17.7359,
                        22.2782,
                        18.4832,
                        21.8071,
                        'C',
                        18.7634,
                        21.627,
                        19.1504,
                        21.7137,
                        19.3239,
                        21.9993,
                        'C',
                        19.4973,
                        22.2862,
                        19.4173,
                        22.6639,
                        19.137,
                        22.8427,
                        'C',
                        18.1896,
                        23.4325,
                        17.082,
                        23.7741,
                        15.8943,
                        23.7741,
                        'C',
                        14.7067,
                        23.7741,
                        13.5991,
                        23.4325,
                        12.6516,
                        22.8427,
                        'C',
                        12.3714,
                        22.6639,
                        12.2913,
                        22.2862,
                        12.4648,
                        21.9993,
                        'C',
                        12.6383,
                        21.7137,
                        13.0253,
                        21.627,
                        13.3055,
                        21.8071,
                        'Z',
                        'M',
                        15.3472,
                        17.7838,
                        'L',
                        14.5332,
                        19.9189,
                        'C',
                        14.4665,
                        20.1071,
                        14.4932,
                        20.3179,
                        14.6133,
                        20.4834,
                        'C',
                        14.72,
                        20.6475,
                        14.9068,
                        20.7463,
                        15.107,
                        20.7463,
                        'L',
                        16.1746,
                        20.7463,
                        'C',
                        16.5215,
                        20.7463,
                        16.7884,
                        20.4727,
                        16.7884,
                        20.1351,
                        'C',
                        16.7884,
                        19.7975,
                        16.5215,
                        19.5239,
                        16.1746,
                        19.5239,
                        'C',
                        16.1746,
                        19.5239,
                        15.9877,
                        19.5239,
                        15.9877,
                        19.5239,
                        'C',
                        15.9877,
                        19.5239,
                        16.4815,
                        18.2148,
                        16.4815,
                        18.2148,
                        'C',
                        16.6016,
                        17.8999,
                        16.4415,
                        17.5463,
                        16.1345,
                        17.4275,
                        'C',
                        15.8143,
                        17.3087,
                        15.4673,
                        17.4689,
                        15.3472,
                        17.7838,
                        'Z',
                        'M',
                        26.2096,
                        15.997,
                        'C',
                        26.9302,
                        16.0584,
                        27.4907,
                        16.6642,
                        27.4907,
                        17.4021,
                        'C',
                        27.4907,
                        18.1401,
                        26.9302,
                        18.7459,
                        26.2096,
                        18.8073,
                        'L',
                        26.2096,
                        15.997,
                        'Z',
                        'M',
                        5.57907,
                        15.997,
                        'L',
                        5.57907,
                        18.8073,
                        'C',
                        4.85847,
                        18.7459,
                        4.298,
                        18.1401,
                        4.298,
                        17.4021,
                        'C',
                        4.298,
                        16.6642,
                        4.85847,
                        16.0584,
                        5.57907,
                        15.997,
                        'Z',
                        'M',
                        11.9844,
                        15.65,
                        'C',
                        12.745,
                        15.65,
                        13.3722,
                        16.2705,
                        13.3722,
                        17.0365,
                        'C',
                        13.3722,
                        17.8011,
                        12.745,
                        18.423,
                        11.9844,
                        18.423,
                        'C',
                        11.2238,
                        18.423,
                        10.5966,
                        17.8011,
                        10.5966,
                        17.0365,
                        'C',
                        10.5966,
                        16.2705,
                        11.2238,
                        15.65,
                        11.9844,
                        15.65,
                        'Z',
                        'M',
                        20.0044,
                        15.65,
                        'C',
                        20.7784,
                        15.65,
                        21.3922,
                        16.2705,
                        21.3922,
                        17.0365,
                        'C',
                        21.3922,
                        17.8011,
                        20.7784,
                        18.423,
                        20.0044,
                        18.423,
                        'C',
                        19.2438,
                        18.423,
                        18.6166,
                        17.8011,
                        18.6166,
                        17.0365,
                        'C',
                        18.6166,
                        16.2705,
                        19.2438,
                        15.65,
                        20.0044,
                        15.65,
                        'Z',
                        'M',
                        24.9819,
                        13.268,
                        'C',
                        24.9152,
                        11.3104,
                        24.1145,
                        9.44485,
                        22.7267,
                        8.0557,
                        'C',
                        21.2855,
                        6.61183,
                        19.3239,
                        5.80048,
                        17.2822,
                        5.80048,
                        'C',
                        16.3614,
                        5.80048,
                        15.4273,
                        5.80048,
                        14.5065,
                        5.80048,
                        'C',
                        12.4648,
                        5.80048,
                        10.5032,
                        6.61183,
                        9.06197,
                        8.0557,
                        'C',
                        7.76756,
                        9.35278,
                        6.98024,
                        11.0635,
                        6.83345,
                        12.877,
                        'C',
                        9.00859,
                        12.3259,
                        11.1837,
                        11.2223,
                        12.9719,
                        9.68505,
                        'C',
                        13.1987,
                        9.49022,
                        13.5324,
                        9.48889,
                        13.7592,
                        9.67972,
                        'C',
                        16.8284,
                        12.2419,
                        20.6183,
                        13.184,
                        24.9819,
                        13.268,
                        'Z'
                      ]
                    },
                    {
                      t: 1700,
                      v: [
                        'M',
                        5.57907,
                        14.7706,
                        'C',
                        4.19125,
                        14.8347,
                        3.07031,
                        15.989,
                        3.07031,
                        17.4021,
                        'C',
                        3.07031,
                        18.8567,
                        4.25797,
                        20.0363,
                        5.71251,
                        20.0363,
                        'L',
                        5.76589,
                        20.0363,
                        'C',
                        6.13954,
                        22.0647,
                        7.12703,
                        23.9476,
                        8.60826,
                        25.4275,
                        'C',
                        10.5432,
                        27.3611,
                        13.1587,
                        28.4474,
                        15.8943,
                        28.4474,
                        'C',
                        18.6299,
                        28.4474,
                        21.2455,
                        27.3611,
                        23.1804,
                        25.4275,
                        'C',
                        24.6616,
                        23.9476,
                        25.6491,
                        22.0647,
                        26.0228,
                        20.0363,
                        'L',
                        26.0761,
                        20.0363,
                        'C',
                        27.5307,
                        20.0363,
                        28.7183,
                        18.8567,
                        28.7183,
                        17.4021,
                        'C',
                        28.7183,
                        15.989,
                        27.5974,
                        14.8347,
                        26.2096,
                        14.7706,
                        'L',
                        26.2096,
                        13.5002,
                        'C',
                        26.2096,
                        11.1343,
                        25.2621,
                        8.86437,
                        23.5941,
                        7.19098,
                        'C',
                        21.9127,
                        5.51758,
                        19.6441,
                        4.57812,
                        17.2822,
                        4.57812,
                        'C',
                        16.3614,
                        4.57812,
                        15.4273,
                        4.57812,
                        14.5065,
                        4.57812,
                        'C',
                        12.1445,
                        4.57812,
                        9.87598,
                        5.51758,
                        8.19458,
                        7.19098,
                        'C',
                        6.52653,
                        8.86437,
                        5.57907,
                        11.1343,
                        5.57907,
                        13.5002,
                        'L',
                        5.57907,
                        14.7706,
                        'Z',
                        'M',
                        24.9819,
                        14.4917,
                        'C',
                        20.4982,
                        14.409,
                        16.5882,
                        13.4442,
                        13.3722,
                        10.9394,
                        'C',
                        11.4239,
                        12.5047,
                        9.11535,
                        13.611,
                        6.80676,
                        14.1421,
                        'L',
                        6.80676,
                        18.1388,
                        'C',
                        6.80676,
                        20.5474,
                        7.76756,
                        22.8587,
                        9.47565,
                        24.5628,
                        'C',
                        11.1704,
                        26.2669,
                        13.479,
                        27.2237,
                        15.8943,
                        27.2237,
                        'C',
                        18.3097,
                        27.2237,
                        20.6183,
                        26.2669,
                        22.313,
                        24.5628,
                        'C',
                        24.0211,
                        22.8587,
                        24.9819,
                        20.5474,
                        24.9819,
                        18.1388,
                        'L',
                        24.9819,
                        14.4917,
                        'Z',
                        'M',
                        13.3055,
                        21.8071,
                        'C',
                        14.0528,
                        22.2782,
                        14.9469,
                        22.5504,
                        15.8943,
                        22.5504,
                        'C',
                        16.8418,
                        22.5504,
                        17.7359,
                        22.2782,
                        18.4832,
                        21.8071,
                        'C',
                        18.7634,
                        21.627,
                        19.1504,
                        21.7137,
                        19.3239,
                        21.9993,
                        'C',
                        19.4973,
                        22.2862,
                        19.4173,
                        22.6639,
                        19.137,
                        22.8427,
                        'C',
                        18.1896,
                        23.4325,
                        17.082,
                        23.7741,
                        15.8943,
                        23.7741,
                        'C',
                        14.7067,
                        23.7741,
                        13.5991,
                        23.4325,
                        12.6516,
                        22.8427,
                        'C',
                        12.3714,
                        22.6639,
                        12.2913,
                        22.2862,
                        12.4648,
                        21.9993,
                        'C',
                        12.6383,
                        21.7137,
                        13.0253,
                        21.627,
                        13.3055,
                        21.8071,
                        'Z',
                        'M',
                        15.3472,
                        17.7838,
                        'L',
                        14.5332,
                        19.9189,
                        'C',
                        14.4665,
                        20.1071,
                        14.4932,
                        20.3179,
                        14.6133,
                        20.4834,
                        'C',
                        14.72,
                        20.6475,
                        14.9068,
                        20.7463,
                        15.107,
                        20.7463,
                        'L',
                        16.1746,
                        20.7463,
                        'C',
                        16.5215,
                        20.7463,
                        16.7884,
                        20.4727,
                        16.7884,
                        20.1351,
                        'C',
                        16.7884,
                        19.7975,
                        16.5215,
                        19.5239,
                        16.1746,
                        19.5239,
                        'C',
                        16.1746,
                        19.5239,
                        15.9877,
                        19.5239,
                        15.9877,
                        19.5239,
                        'C',
                        15.9877,
                        19.5239,
                        16.4815,
                        18.2148,
                        16.4815,
                        18.2148,
                        'C',
                        16.6016,
                        17.8999,
                        16.4415,
                        17.5463,
                        16.1345,
                        17.4275,
                        'C',
                        15.8143,
                        17.3087,
                        15.4673,
                        17.4689,
                        15.3472,
                        17.7838,
                        'Z',
                        'M',
                        26.2096,
                        15.997,
                        'C',
                        26.9302,
                        16.0584,
                        27.4907,
                        16.6642,
                        27.4907,
                        17.4021,
                        'C',
                        27.4907,
                        18.1401,
                        26.9302,
                        18.7459,
                        26.2096,
                        18.8073,
                        'L',
                        26.2096,
                        15.997,
                        'Z',
                        'M',
                        5.57907,
                        15.997,
                        'L',
                        5.57907,
                        18.8073,
                        'C',
                        4.85847,
                        18.7459,
                        4.298,
                        18.1401,
                        4.298,
                        17.4021,
                        'C',
                        4.298,
                        16.6642,
                        4.85847,
                        16.0584,
                        5.57907,
                        15.997,
                        'Z',
                        'M',
                        11.9844,
                        15.65,
                        'C',
                        12.745,
                        15.65,
                        13.3722,
                        16.2705,
                        13.3722,
                        17.0365,
                        'C',
                        13.3722,
                        17.8011,
                        12.745,
                        18.423,
                        11.9844,
                        18.423,
                        'C',
                        11.2238,
                        18.423,
                        10.5966,
                        17.8011,
                        10.5966,
                        17.0365,
                        'C',
                        10.5966,
                        16.2705,
                        11.2238,
                        15.65,
                        11.9844,
                        15.65,
                        'Z',
                        'M',
                        20.0044,
                        15.65,
                        'C',
                        20.7784,
                        15.65,
                        21.3922,
                        16.2705,
                        21.3922,
                        17.0365,
                        'C',
                        21.3922,
                        17.8011,
                        20.7784,
                        18.423,
                        20.0044,
                        18.423,
                        'C',
                        19.2438,
                        18.423,
                        18.6166,
                        17.8011,
                        18.6166,
                        17.0365,
                        'C',
                        18.6166,
                        16.2705,
                        19.2438,
                        15.65,
                        20.0044,
                        15.65,
                        'Z',
                        'M',
                        24.9819,
                        13.268,
                        'C',
                        24.9152,
                        11.3104,
                        24.1145,
                        9.44485,
                        22.7267,
                        8.0557,
                        'C',
                        21.2855,
                        6.61183,
                        19.3239,
                        5.80048,
                        17.2822,
                        5.80048,
                        'C',
                        16.3614,
                        5.80048,
                        15.4273,
                        5.80048,
                        14.5065,
                        5.80048,
                        'C',
                        12.4648,
                        5.80048,
                        10.5032,
                        6.61183,
                        9.06197,
                        8.0557,
                        'C',
                        7.76756,
                        9.35278,
                        6.98024,
                        11.0635,
                        6.83345,
                        12.877,
                        'C',
                        9.00859,
                        12.3259,
                        11.1837,
                        11.2223,
                        12.9719,
                        9.68505,
                        'C',
                        13.1987,
                        9.49022,
                        13.5324,
                        9.48889,
                        13.7592,
                        9.67972,
                        'C',
                        16.8284,
                        12.2419,
                        20.6183,
                        13.184,
                        24.9819,
                        13.268,
                        'Z'
                      ]
                    },
                    {
                      t: 1800,
                      v: [
                        'M',
                        5.57907,
                        14.7706,
                        'C',
                        4.19125,
                        14.8347,
                        3.07031,
                        15.989,
                        3.07031,
                        17.4021,
                        'C',
                        3.07031,
                        18.8567,
                        4.25797,
                        20.0363,
                        5.71251,
                        20.0363,
                        'L',
                        5.76589,
                        20.0363,
                        'C',
                        6.13954,
                        22.0647,
                        7.12703,
                        23.9476,
                        8.60826,
                        25.4275,
                        'C',
                        10.5432,
                        27.3611,
                        13.1587,
                        28.4474,
                        15.8943,
                        28.4474,
                        'C',
                        18.6299,
                        28.4474,
                        21.2455,
                        27.3611,
                        23.1804,
                        25.4275,
                        'C',
                        24.6616,
                        23.9476,
                        25.6491,
                        22.0647,
                        26.0228,
                        20.0363,
                        'L',
                        26.0761,
                        20.0363,
                        'C',
                        27.5307,
                        20.0363,
                        28.7183,
                        18.8567,
                        28.7183,
                        17.4021,
                        'C',
                        28.7183,
                        15.989,
                        27.5974,
                        14.8347,
                        26.2096,
                        14.7706,
                        'L',
                        26.2096,
                        13.5002,
                        'C',
                        26.2096,
                        11.1343,
                        25.2621,
                        8.86437,
                        23.5941,
                        7.19098,
                        'C',
                        21.9127,
                        5.51758,
                        19.6441,
                        4.57812,
                        17.2822,
                        4.57812,
                        'C',
                        16.3614,
                        4.57812,
                        15.4273,
                        4.57812,
                        14.5065,
                        4.57812,
                        'C',
                        12.1445,
                        4.57812,
                        9.87598,
                        5.51758,
                        8.19458,
                        7.19098,
                        'C',
                        6.52653,
                        8.86437,
                        5.57907,
                        11.1343,
                        5.57907,
                        13.5002,
                        'L',
                        5.57907,
                        14.7706,
                        'Z',
                        'M',
                        24.9819,
                        14.4917,
                        'C',
                        20.4982,
                        14.409,
                        16.5882,
                        13.4442,
                        13.3722,
                        10.9394,
                        'C',
                        11.4239,
                        12.5047,
                        9.11535,
                        13.611,
                        6.80676,
                        14.1421,
                        'L',
                        6.80676,
                        18.1388,
                        'C',
                        6.80676,
                        20.5474,
                        7.76756,
                        22.8587,
                        9.47565,
                        24.5628,
                        'C',
                        11.1704,
                        26.2669,
                        13.479,
                        27.2237,
                        15.8943,
                        27.2237,
                        'C',
                        18.3097,
                        27.2237,
                        20.6183,
                        26.2669,
                        22.313,
                        24.5628,
                        'C',
                        24.0211,
                        22.8587,
                        24.9819,
                        20.5474,
                        24.9819,
                        18.1388,
                        'L',
                        24.9819,
                        14.4917,
                        'Z',
                        'M',
                        13.3055,
                        21.8071,
                        'C',
                        14.0528,
                        22.2782,
                        14.9469,
                        22.5504,
                        15.8943,
                        22.5504,
                        'C',
                        16.8418,
                        22.5504,
                        17.7359,
                        22.2782,
                        18.4832,
                        21.8071,
                        'C',
                        18.7634,
                        21.627,
                        19.1504,
                        21.7137,
                        19.3239,
                        21.9993,
                        'C',
                        19.4973,
                        22.2862,
                        19.4173,
                        22.6639,
                        19.137,
                        22.8427,
                        'C',
                        18.1896,
                        23.4325,
                        17.082,
                        23.7741,
                        15.8943,
                        23.7741,
                        'C',
                        14.7067,
                        23.7741,
                        13.5991,
                        23.4325,
                        12.6516,
                        22.8427,
                        'C',
                        12.3714,
                        22.6639,
                        12.2913,
                        22.2862,
                        12.4648,
                        21.9993,
                        'C',
                        12.6383,
                        21.7137,
                        13.0253,
                        21.627,
                        13.3055,
                        21.8071,
                        'Z',
                        'M',
                        15.3472,
                        17.7838,
                        'L',
                        14.5332,
                        19.9189,
                        'C',
                        14.4665,
                        20.1071,
                        14.4932,
                        20.3179,
                        14.6133,
                        20.4834,
                        'C',
                        14.72,
                        20.6475,
                        14.9068,
                        20.7463,
                        15.107,
                        20.7463,
                        'L',
                        16.1746,
                        20.7463,
                        'C',
                        16.5215,
                        20.7463,
                        16.7884,
                        20.4727,
                        16.7884,
                        20.1351,
                        'C',
                        16.7884,
                        19.7975,
                        16.5215,
                        19.5239,
                        16.1746,
                        19.5239,
                        'C',
                        16.1746,
                        19.5239,
                        15.9877,
                        19.5239,
                        15.9877,
                        19.5239,
                        'C',
                        15.9877,
                        19.5239,
                        16.4815,
                        18.2148,
                        16.4815,
                        18.2148,
                        'C',
                        16.6016,
                        17.8999,
                        16.4415,
                        17.5463,
                        16.1345,
                        17.4275,
                        'C',
                        15.8143,
                        17.3087,
                        15.4673,
                        17.4689,
                        15.3472,
                        17.7838,
                        'Z',
                        'M',
                        26.2096,
                        15.997,
                        'C',
                        26.9302,
                        16.0584,
                        27.4907,
                        16.6642,
                        27.4907,
                        17.4021,
                        'C',
                        27.4907,
                        18.1401,
                        26.9302,
                        18.7459,
                        26.2096,
                        18.8073,
                        'L',
                        26.2096,
                        15.997,
                        'Z',
                        'M',
                        5.57907,
                        15.997,
                        'L',
                        5.57907,
                        18.8073,
                        'C',
                        4.85847,
                        18.7459,
                        4.298,
                        18.1401,
                        4.298,
                        17.4021,
                        'C',
                        4.298,
                        16.6642,
                        4.85847,
                        16.0584,
                        5.57907,
                        15.997,
                        'Z',
                        'M',
                        11.9844,
                        16.65,
                        'C',
                        12.745,
                        16.65,
                        13.3722,
                        16.564717,
                        13.3722,
                        17.0365,
                        'C',
                        13.3722,
                        17.524717,
                        12.745,
                        17.423,
                        11.9844,
                        17.423,
                        'C',
                        11.2238,
                        17.423,
                        10.5966,
                        17.524717,
                        10.5966,
                        17.0365,
                        'C',
                        10.5966,
                        16.584717,
                        11.2238,
                        16.65,
                        11.9844,
                        16.65,
                        'Z',
                        'M',
                        20.0044,
                        16.65,
                        'C',
                        20.7784,
                        16.65,
                        21.3922,
                        16.544716,
                        21.3922,
                        17.0365,
                        'C',
                        21.3922,
                        17.544717,
                        20.7784,
                        17.423,
                        20.0044,
                        17.423,
                        'C',
                        19.2438,
                        17.423,
                        18.6166,
                        17.504717,
                        18.6166,
                        17.0365,
                        'C',
                        18.6166,
                        16.524717,
                        19.2438,
                        16.65,
                        20.0044,
                        16.65,
                        'Z',
                        'M',
                        24.9819,
                        13.268,
                        'C',
                        24.9152,
                        11.3104,
                        24.1145,
                        9.44485,
                        22.7267,
                        8.0557,
                        'C',
                        21.2855,
                        6.61183,
                        19.3239,
                        5.80048,
                        17.2822,
                        5.80048,
                        'C',
                        16.3614,
                        5.80048,
                        15.4273,
                        5.80048,
                        14.5065,
                        5.80048,
                        'C',
                        12.4648,
                        5.80048,
                        10.5032,
                        6.61183,
                        9.06197,
                        8.0557,
                        'C',
                        7.76756,
                        9.35278,
                        6.98024,
                        11.0635,
                        6.83345,
                        12.877,
                        'C',
                        9.00859,
                        12.3259,
                        11.1837,
                        11.2223,
                        12.9719,
                        9.68505,
                        'C',
                        13.1987,
                        9.49022,
                        13.5324,
                        9.48889,
                        13.7592,
                        9.67972,
                        'C',
                        16.8284,
                        12.2419,
                        20.6183,
                        13.184,
                        24.9819,
                        13.268,
                        'Z'
                      ]
                    },
                    {
                      t: 1900,
                      v: [
                        'M',
                        5.57907,
                        14.7706,
                        'C',
                        4.19125,
                        14.8347,
                        3.07031,
                        15.989,
                        3.07031,
                        17.4021,
                        'C',
                        3.07031,
                        18.8567,
                        4.25797,
                        20.0363,
                        5.71251,
                        20.0363,
                        'L',
                        5.76589,
                        20.0363,
                        'C',
                        6.13954,
                        22.0647,
                        7.12703,
                        23.9476,
                        8.60826,
                        25.4275,
                        'C',
                        10.5432,
                        27.3611,
                        13.1587,
                        28.4474,
                        15.8943,
                        28.4474,
                        'C',
                        18.6299,
                        28.4474,
                        21.2455,
                        27.3611,
                        23.1804,
                        25.4275,
                        'C',
                        24.6616,
                        23.9476,
                        25.6491,
                        22.0647,
                        26.0228,
                        20.0363,
                        'L',
                        26.0761,
                        20.0363,
                        'C',
                        27.5307,
                        20.0363,
                        28.7183,
                        18.8567,
                        28.7183,
                        17.4021,
                        'C',
                        28.7183,
                        15.989,
                        27.5974,
                        14.8347,
                        26.2096,
                        14.7706,
                        'L',
                        26.2096,
                        13.5002,
                        'C',
                        26.2096,
                        11.1343,
                        25.2621,
                        8.86437,
                        23.5941,
                        7.19098,
                        'C',
                        21.9127,
                        5.51758,
                        19.6441,
                        4.57812,
                        17.2822,
                        4.57812,
                        'C',
                        16.3614,
                        4.57812,
                        15.4273,
                        4.57812,
                        14.5065,
                        4.57812,
                        'C',
                        12.1445,
                        4.57812,
                        9.87598,
                        5.51758,
                        8.19458,
                        7.19098,
                        'C',
                        6.52653,
                        8.86437,
                        5.57907,
                        11.1343,
                        5.57907,
                        13.5002,
                        'L',
                        5.57907,
                        14.7706,
                        'Z',
                        'M',
                        24.9819,
                        14.4917,
                        'C',
                        20.4982,
                        14.409,
                        16.5882,
                        13.4442,
                        13.3722,
                        10.9394,
                        'C',
                        11.4239,
                        12.5047,
                        9.11535,
                        13.611,
                        6.80676,
                        14.1421,
                        'L',
                        6.80676,
                        18.1388,
                        'C',
                        6.80676,
                        20.5474,
                        7.76756,
                        22.8587,
                        9.47565,
                        24.5628,
                        'C',
                        11.1704,
                        26.2669,
                        13.479,
                        27.2237,
                        15.8943,
                        27.2237,
                        'C',
                        18.3097,
                        27.2237,
                        20.6183,
                        26.2669,
                        22.313,
                        24.5628,
                        'C',
                        24.0211,
                        22.8587,
                        24.9819,
                        20.5474,
                        24.9819,
                        18.1388,
                        'L',
                        24.9819,
                        14.4917,
                        'Z',
                        'M',
                        13.3055,
                        21.8071,
                        'C',
                        14.0528,
                        22.2782,
                        14.9469,
                        22.5504,
                        15.8943,
                        22.5504,
                        'C',
                        16.8418,
                        22.5504,
                        17.7359,
                        22.2782,
                        18.4832,
                        21.8071,
                        'C',
                        18.7634,
                        21.627,
                        19.1504,
                        21.7137,
                        19.3239,
                        21.9993,
                        'C',
                        19.4973,
                        22.2862,
                        19.4173,
                        22.6639,
                        19.137,
                        22.8427,
                        'C',
                        18.1896,
                        23.4325,
                        17.082,
                        23.7741,
                        15.8943,
                        23.7741,
                        'C',
                        14.7067,
                        23.7741,
                        13.5991,
                        23.4325,
                        12.6516,
                        22.8427,
                        'C',
                        12.3714,
                        22.6639,
                        12.2913,
                        22.2862,
                        12.4648,
                        21.9993,
                        'C',
                        12.6383,
                        21.7137,
                        13.0253,
                        21.627,
                        13.3055,
                        21.8071,
                        'Z',
                        'M',
                        15.3472,
                        17.7838,
                        'L',
                        14.5332,
                        19.9189,
                        'C',
                        14.4665,
                        20.1071,
                        14.4932,
                        20.3179,
                        14.6133,
                        20.4834,
                        'C',
                        14.72,
                        20.6475,
                        14.9068,
                        20.7463,
                        15.107,
                        20.7463,
                        'L',
                        16.1746,
                        20.7463,
                        'C',
                        16.5215,
                        20.7463,
                        16.7884,
                        20.4727,
                        16.7884,
                        20.1351,
                        'C',
                        16.7884,
                        19.7975,
                        16.5215,
                        19.5239,
                        16.1746,
                        19.5239,
                        'C',
                        16.1746,
                        19.5239,
                        15.9877,
                        19.5239,
                        15.9877,
                        19.5239,
                        'C',
                        15.9877,
                        19.5239,
                        16.4815,
                        18.2148,
                        16.4815,
                        18.2148,
                        'C',
                        16.6016,
                        17.8999,
                        16.4415,
                        17.5463,
                        16.1345,
                        17.4275,
                        'C',
                        15.8143,
                        17.3087,
                        15.4673,
                        17.4689,
                        15.3472,
                        17.7838,
                        'Z',
                        'M',
                        26.2096,
                        15.997,
                        'C',
                        26.9302,
                        16.0584,
                        27.4907,
                        16.6642,
                        27.4907,
                        17.4021,
                        'C',
                        27.4907,
                        18.1401,
                        26.9302,
                        18.7459,
                        26.2096,
                        18.8073,
                        'L',
                        26.2096,
                        15.997,
                        'Z',
                        'M',
                        5.57907,
                        15.997,
                        'L',
                        5.57907,
                        18.8073,
                        'C',
                        4.85847,
                        18.7459,
                        4.298,
                        18.1401,
                        4.298,
                        17.4021,
                        'C',
                        4.298,
                        16.6642,
                        4.85847,
                        16.0584,
                        5.57907,
                        15.997,
                        'Z',
                        'M',
                        11.9844,
                        15.65,
                        'C',
                        12.745,
                        15.65,
                        13.3722,
                        16.2705,
                        13.3722,
                        17.0365,
                        'C',
                        13.3722,
                        17.8011,
                        12.745,
                        18.423,
                        11.9844,
                        18.423,
                        'C',
                        11.2238,
                        18.423,
                        10.5966,
                        17.8011,
                        10.5966,
                        17.0365,
                        'C',
                        10.5966,
                        16.2705,
                        11.2238,
                        15.65,
                        11.9844,
                        15.65,
                        'Z',
                        'M',
                        20.0044,
                        15.65,
                        'C',
                        20.7784,
                        15.65,
                        21.3922,
                        16.2705,
                        21.3922,
                        17.0365,
                        'C',
                        21.3922,
                        17.8011,
                        20.7784,
                        18.423,
                        20.0044,
                        18.423,
                        'C',
                        19.2438,
                        18.423,
                        18.6166,
                        17.8011,
                        18.6166,
                        17.0365,
                        'C',
                        18.6166,
                        16.2705,
                        19.2438,
                        15.65,
                        20.0044,
                        15.65,
                        'Z',
                        'M',
                        24.9819,
                        13.268,
                        'C',
                        24.9152,
                        11.3104,
                        24.1145,
                        9.44485,
                        22.7267,
                        8.0557,
                        'C',
                        21.2855,
                        6.61183,
                        19.3239,
                        5.80048,
                        17.2822,
                        5.80048,
                        'C',
                        16.3614,
                        5.80048,
                        15.4273,
                        5.80048,
                        14.5065,
                        5.80048,
                        'C',
                        12.4648,
                        5.80048,
                        10.5032,
                        6.61183,
                        9.06197,
                        8.0557,
                        'C',
                        7.76756,
                        9.35278,
                        6.98024,
                        11.0635,
                        6.83345,
                        12.877,
                        'C',
                        9.00859,
                        12.3259,
                        11.1837,
                        11.2223,
                        12.9719,
                        9.68505,
                        'C',
                        13.1987,
                        9.49022,
                        13.5324,
                        9.48889,
                        13.7592,
                        9.67972,
                        'C',
                        16.8284,
                        12.2419,
                        20.6183,
                        13.184,
                        24.9819,
                        13.268,
                        'Z'
                      ]
                    }
                  ]
                }
              },
              s: 'MDMA1ZGQwNzdiOOWNhYzdiNmM5DYmVSYzRjMzcI3OGY4ODg1ODGU4NTgxNzdiOXWJlRWM3YmFiCOGM5YmVjNGMXzNzdLOGY4NjYgxNzdiZWM5YSmFjN2I2YzliXZUNjNGMzYzgY3NzhmODY4MTIc3YmJiZWMxYXzE3NzhmODY4CMTc3YjZjMWMA5YmFKYzdjM2BI2YzliYTc3VTjhmYmJiNmMxHYzhiYTgxNzdNjOGM1YmFiYWKI5Nzc4Zjg2VQDgxNzdiYlVjRNWM4Nzc4ZjgW2ODU4NWQy'
            }
          ],
          options: 'MDOAxMDgyMjk3YIVQ3YjY4Nzk3PYjI5NDEyOTcHzTDc2Njg2YjDI5ODQ/'
        },
        '__SVGATOR_PLAYER__',
        window,
        document
      );

      const svg = document.getElementById('emDeTYZbN5z1');
      this.player = svg && svg.svgatorPlayer;
      if (!this.player) {
        return;
      }

      this.$eventHub.$on(this.eventName, () => {
        this.player.play();
      });
    }, 500);
  }
};
</script>
